<template>
  <v-container>
    <app-navigation></app-navigation>
    <v-main class="pt-12">
      <div class="pt-md-5">
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 class="mx-1 mb-1 pa-0">
            <main-sub-page-toolbar icon="mdi-image-album">
              {{ $t("dashboardCardSuperAdminImageTemplate") }} ({{
                getModuleName($route.params.subPath)
              }})
            </main-sub-page-toolbar>
          </v-flex>
          <v-flex xs12 class="mx-1 mb-1 pa-0">
            <div>
              <data-table-search-toolbar
                :search.sync="search"
              ></data-table-search-toolbar>
              <v-data-table
                :loading-text="$t('lmPleaseWait')"
                class="#505050--text"
                :class="
                  getTheme() == 'dark'
                    ? 'outlined elevation-0'
                    : 'flat elevation-0'
                "
                :style="
                  getTheme() == 'dark'
                    ? 'border: 1px solid darkgray; border-top: none; background-color: white'
                    : 'border: none; background-color: white'
                "
                :headers="headers"
                :items="$store.state.storeImageTemplate.imageTemplate"
                :search="search"
                sort-by="code"
                :items-per-page="-1"
                must-sort
                show-expand
                :no-results-text="$t('dataGridSlotNoResults')"
                :no-data-text="$t('dataGridSlotNoData')"
                :footer-props="{
                  itemsPerPageText: $t('dataGridRowsPerPageText'),
                  itemsPerPageAllText: $t('dataGridRowsPerPageAllText'),
                }"
              >
                <template v-slot:expanded-item="{ item }">
                  <td :colspan="headers.length" class="py-2">
                    <div class="py-1 overline">
                      {{ $t("settingsImageTemplateGridHeaderRulesTitle") }}
                    </div>
                    <div class="py-1">{{ item.width }}x{{ item.height }}px</div>
                    <div class="py-1 overline">
                      {{
                        $t(
                          "settingsImageTemplateGridHeaderAllowAutoPreviewTitle"
                        )
                      }}
                    </div>
                    <div class="py-1">
                      <v-img
                        v-if="item.imagePr != ''"
                        :src="item.imagePr"
                        style="max-width: 400px"
                      ></v-img>
                    </div>
                    <div class="py-1 overline">
                      {{ $t("settingsImageTemplateGHPermissionsTitle") }}
                    </div>
                    <div class="py-1">
                      <v-icon
                        class="mr-1"
                        :color="item.allowTransparentBack ? 'success' : 'error'"
                      >
                        {{
                          item.allowTransparentBack
                            ? "mdi-check-circle-outline"
                            : "mdi-close-circle-outline"
                        }}
                      </v-icon>
                      {{
                        $t("settingsImageTemplateGHAllowTransparentBackTitle")
                      }}
                    </div>
                    <div class="py-1">
                      <v-icon
                        class="mr-1"
                        :color="item.allowBackground ? 'success' : 'error'"
                      >
                        {{
                          item.allowBackground
                            ? "mdi-check-circle-outline"
                            : "mdi-close-circle-outline"
                        }}
                      </v-icon>
                      {{ $t("settingsImageTemplateGHAllowBackgroundTitle") }}
                    </div>
                    <div class="py-1">
                      <v-icon
                        class="mr-1"
                        :color="item.mainImageBackground ? 'success' : 'error'"
                      >
                        {{
                          item.mainImageBackground
                            ? "mdi-check-circle-outline"
                            : "mdi-close-circle-outline"
                        }}
                      </v-icon>
                      {{
                        $t("settingsImageTemplateGHMainImageBackgroundTitle")
                      }}
                    </div>
                    <div class="py-1">
                      <v-icon
                        class="mr-1"
                        :color="item.allowImages ? 'success' : 'error'"
                      >
                        {{
                          item.allowImages
                            ? "mdi-check-circle-outline"
                            : "mdi-close-circle-outline"
                        }}
                      </v-icon>
                      {{ $t("settingsImageTemplateGHAllowImagesTitle") }}
                    </div>
                    <div class="py-1">
                      <v-icon
                        class="mr-1"
                        :color="item.allowText ? 'success' : 'error'"
                      >
                        {{
                          item.allowText
                            ? "mdi-check-circle-outline"
                            : "mdi-close-circle-outline"
                        }}
                      </v-icon>
                      {{ $t("settingsImageTemplateGHAllowTextTitle") }}
                    </div>
                    <div class="py-1">
                      <v-icon
                        class="mr-1"
                        :color="item.allowFreeDrawing ? 'success' : 'error'"
                      >
                        {{
                          item.allowFreeDrawing
                            ? "mdi-check-circle-outline"
                            : "mdi-close-circle-outline"
                        }}
                      </v-icon>
                      {{ $t("settingsImageTemplateGHAllowFreeDrawingTitle") }}
                    </div>
                    <div class="py-1">
                      <v-icon
                        class="mr-1"
                        :color="item.allowStickers ? 'success' : 'error'"
                      >
                        {{
                          item.allowStickers
                            ? "mdi-check-circle-outline"
                            : "mdi-close-circle-outline"
                        }}
                      </v-icon>
                      {{ $t("settingsImageTemplateGHAllowStickersTitle") }}
                    </div>
                    <div class="py-1 overline">
                      {{
                        $t("settingsImageTemplateGridHeaderDescriptionTitle")
                      }}
                    </div>
                    <div class="py-1">{{ item.description }}</div>
                    <div class="py-1 overline">
                      {{
                        $t("settingsImageTemplateGridHeaderInstructionsTitle")
                      }}
                    </div>
                    <div class="py-1">{{ item.instructions }}</div>
                  </td>
                </template>
                <template v-slot:item.private="{ item }">
                  <v-icon
                    @click="toggleImageTemplateBooleanPrivate(item)"
                    :color="item.private ? 'success' : 'error'"
                    >{{
                      item.private
                        ? "mdi-check-circle-outline"
                        : "mdi-close-circle-outline"
                    }}</v-icon
                  >
                </template>
                <template v-slot:item.active="{ item }">
                  <v-icon
                    @click="toggleImageTemplateBooleanActive(item)"
                    :color="item.active ? 'success' : 'error'"
                    >{{
                      item.active
                        ? "mdi-check-circle-outline"
                        : "mdi-close-circle-outline"
                    }}</v-icon
                  >
                </template>
                <template v-slot:item.code="{ item }">
                  <v-chip :color="getColor(item.active)">
                    {{ item.code }}
                  </v-chip>
                </template>
                <template v-slot:item.actions="{ item }">
                  <div class="d-flex flex-no-wrap">
                    <v-icon class="mr-3" @click="copyItem(item)"
                      >mdi-content-copy</v-icon
                    >
                    <v-icon class="mr-3" @click="editItem(item)"
                      >mdi-pencil</v-icon
                    >
                    <v-icon class="mr-3" @click="initEditRules(item)"
                      >mdi-image-edit</v-icon
                    >
                    <v-icon @click="deleteItemSet(item.id)">mdi-delete</v-icon>
                  </div>
                </template>
                <template v-slot:item.previewImage="{ item }">
                  <v-img
                    v-if="!item.allowAutoPreview"
                    :src="
                      item.previewImage.length > 0
                        ? item.previewImage
                        : defaultImage
                    "
                    :style="
                      item.previewImage.length > 0
                        ? 'max-width: 100px'
                        : 'max-width: 50px'
                    "
                  ></v-img>
                  <v-img
                    v-else
                    :src="item.imagePr.length > 0 ? item.imagePr : defaultImage"
                    :style="
                      item.imagePr.length > 0
                        ? 'max-width: 100px'
                        : 'max-width: 50px'
                    "
                  ></v-img>
                </template>
                <template v-slot:item.createdTimestamp="{ item }">
                  {{ item.createdTimestamp.seconds | formatDate }}
                </template>
                <template v-slot:item.editedTimestamp="{ item }">
                  {{ item.editedTimestamp.seconds | formatDate }}
                </template>
              </v-data-table>
            </div>

            <!-- DELETE CONFIRM DIALOG -->
            <dialog-basic-yes-no
              :active="dialogDelete"
              @clickYes="deleteItem"
              @clickNo="dialogDelete = false"
              icon="mdi-comment-question-outline"
              :title="$t('msgQuestion')"
              >{{ $t("deleteDialogQuestion") }}</dialog-basic-yes-no
            >
          </v-flex>
          <simple-navigation-button
            left
            :title="$t('lmBtnBack')"
            icon="mdi-arrow-left"
            @clicked="$router.go(-1)"
          ></simple-navigation-button>

          <!-- PLEASE WAIT DIALOG -->
          <v-dialog
            v-model="dialogWait"
            persistent
            max-width="400"
            transition="dialog-bottom-transition"
          >
            <v-card>
              <v-card-title class="headline">
                {{ $t("userNewOrderPleaseWaitTitle") }}
              </v-card-title>
              <v-card-text class="d-flex">
                <v-spacer></v-spacer>
                <v-progress-linear
                  color="primary"
                  height="10"
                  indeterminate
                ></v-progress-linear>
                <v-spacer></v-spacer>
              </v-card-text>
            </v-card>
          </v-dialog>

          <!-- ADD / EDIT DIALOG -->
          <v-dialog
            v-model="dialog"
            max-width="1200px"
            persistent
            transition="dialog-bottom-transition"
          >
            <template v-slot:activator="{ on }">
              <v-btn color="primary" v-on="on" dark fixed bottom right rounded>
                <v-icon medium class="mr-1">mdi-plus</v-icon>
                {{ $t("lmBtnAdd") }}
              </v-btn>
            </template>
            <v-form ref="form" v-model="valid">
              <v-card
                :class="
                  getTheme() == 'dark'
                    ? 'outlined elevation-0'
                    : 'flat elevation-0'
                "
                :style="
                  getTheme() == 'dark'
                    ? ''
                    : 'border-bottom: 1px solid lightgray'
                "
              >
                <v-card-title
                  :style="
                    getTheme() == 'dark'
                      ? 'background-color: #505050'
                      : 'background-color: white; border-bottom: 1px solid lightgray'
                  "
                  :class="
                    getTheme() == 'dark' ? 'white--text' : '#505050--text'
                  "
                  class="title font-weight-regular"
                >
                  <v-icon
                    :class="
                      getTheme() == 'dark' ? 'white--text' : 'primary--text'
                    "
                    class="mr-3"
                    medium
                  >
                    {{ this.editedIndex == -1 ? "mdi-plus" : "mdi-pencil" }}
                  </v-icon>
                  {{ formTitle }}
                </v-card-title>
                <v-card-text class="py-0 pt-2">
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-text-field
                          dense
                          v-model="editedItem.order"
                          type="number"
                          :label="$t('settingsPhotoGiftCategoryOrderTitle')"
                          :rules="[validateRequired(), validateIsNumber()]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          dense
                          v-model="editedItem.code"
                          :label="
                            $t('settingsImageTemplateGridHeaderCodeTitle')
                          "
                          :rules="[validateRequired(), validateMaxLength(50)]"
                          :counter="50"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          dense
                          v-model="editedItem.title"
                          :label="
                            $t('settingsImageTemplateGridHeaderTitleTitle')
                          "
                          :rules="[validateRequired(), validateMaxLength(150)]"
                          :counter="150"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          dense
                          v-model="editedItem.keywords"
                          :label="$t('settingsImageTemplateKeywordsTitle')"
                          :rules="[validateMaxLength(500)]"
                          :counter="500"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-textarea
                          v-model="editedItem.description"
                          :label="
                            $t(
                              'settingsImageTemplateGridHeaderDescriptionTitle'
                            )
                          "
                          :rules="[validateMaxLength(350)]"
                          :counter="350"
                          dense
                        ></v-textarea>
                      </v-flex>
                      <v-flex xs12>
                        <tiptap-vuetify
                          :placeholder="
                            $t(
                              'settingsImageTemplateGridHeaderInstructionsTitle'
                            )
                          "
                          v-model="editedItem.instructions"
                          :extensions="extensions"
                          :card-props="{ flat: true, color: '#e1e1e1' }"
                        />
                      </v-flex>
                      <v-flex xs12 v-show="!editedItem.allowAutoPreview">
                        <v-file-input
                          clearable
                          accept="image/jpeg, image/png"
                          prepend-icon="mdi-camera"
                          v-model="editedItem.previewImage"
                          class="mt-0 pa-0"
                          :label="
                            $t(
                              'settingsImageTemplateGridHeaderPreviewImageTitle'
                            )
                          "
                        ></v-file-input>
                      </v-flex>
                      <v-flex xs12>
                        <v-switch
                          dense
                          style="height: 30px"
                          class="ma-0 pa-0"
                          v-model="editedItem.allowAutoPreview"
                          :label="
                            $t(
                              'settingsImageTemplateGridHeaderAllowAutoPreviewTitle'
                            )
                          "
                          @change="
                            editedItem.previewImage = [];
                            editedItem.previewImageURL = '';
                          "
                        ></v-switch>
                      </v-flex>
                      <v-flex xs12>
                        <v-switch
                          dense
                          style="height: 30px"
                          class="ma-0 pa-0"
                          v-model="editedItem.private"
                          :label="
                            $t('settingsImageTemplateGridHeaderPrivateTitle')
                          "
                        ></v-switch>
                      </v-flex>
                      <v-flex xs12>
                        <v-switch
                          dense
                          style="height: 30px"
                          class="ma-0 pa-0"
                          v-model="editedItem.active"
                          :label="
                            $t('settingsImageTemplateGridHeaderActiveTitle')
                          "
                        ></v-switch>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions
                  :class="
                    getTheme() == 'dark' ? '#505050--text' : '#505050--text'
                  "
                  :style="
                    getTheme() == 'dark'
                      ? 'background-color: whitesmoke; border-top: 1px solid lightgray;'
                      : 'background-color: white; border-top: 1px solid lightgray;'
                  "
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    class="my-1 mr-5"
                    text
                    @click="
                      close();
                      refresh();
                    "
                    >{{ $t("addEditFormCancelButton") }}</v-btn
                  >
                  <v-btn @click="save" color="primary" dark class="ml-5">
                    <v-icon medium class="mr-1">mdi-content-save</v-icon>
                    {{ $t("addEditFormSaveButton") }}
                  </v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-dialog>

          <!-- EDIT TEMPLATE DIALOG -->
          <v-dialog
            v-model="dialogEditTemplate"
            persistent
            style="z-index: 2000"
            :fullscreen="true"
            :scrollable="true"
            transition="dialog-bottom-transition"
          >
            <v-form ref="formRules" v-model="validRules">
              <v-card
                :class="
                  getTheme() == 'dark'
                    ? 'outlined elevation-0'
                    : 'flat elevation-0'
                "
                :style="
                  getTheme() == 'dark'
                    ? ''
                    : 'border-bottom: 1px solid lightgray'
                "
              >
                <v-card-title
                  :style="
                    getTheme() == 'dark'
                      ? 'background-color: #505050'
                      : 'background-color: white; border-bottom: 1px solid lightgray'
                  "
                  :class="
                    getTheme() == 'dark' ? 'white--text' : '#505050--text'
                  "
                  class="title font-weight-regular"
                >
                  <v-icon
                    :class="
                      getTheme() == 'dark' ? 'white--text' : 'primary--text'
                    "
                    class="mr-3"
                    medium
                    >mdi-image-edit</v-icon
                  >
                  {{ $t("settingsImageTemplateGridHeaderRulesTitle") }}
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    medium
                    @click="
                      dialogEditTemplate = false;
                      refresh();
                    "
                    style="min-width: 0; width: 20px"
                  >
                    <v-icon
                      medium
                      :class="
                        getTheme() == 'dark' ? 'white--text' : 'primary--text'
                      "
                      >mdi-close-box</v-icon
                    >
                  </v-btn>
                </v-card-title>

                <v-card-text class="d-flex ma-0 pa-2" style="overflow: hidden">
                  <v-flex xs4 style="overflow-y: scroll">
                    <v-flex
                      xs12
                      style="height: 66px; border-bottom: 1px dashed silver"
                      class="d-flex mb-4"
                    >
                      <v-text-field
                        class="mx-2"
                        v-model="currentItem.width"
                        :label="$t('settingsImageTemplateGridHeaderWidthTitle')"
                        :rules="[validateRequired(), validateIsNumber()]"
                      ></v-text-field>
                      <v-text-field
                        class="mr-2"
                        v-model="currentItem.height"
                        :label="
                          $t('settingsImageTemplateGridHeaderHeightTitle')
                        "
                        :rules="[validateRequired(), validateIsNumber()]"
                      ></v-text-field>
                      <v-btn
                        middle
                        text
                        outlined
                        color="secondary"
                        class="mr-2 mt-2 elevation-0"
                        @click="resetCurrentItem"
                      >
                        <v-icon class="mr-2">mdi-image-move</v-icon>
                        {{ $t("lmBtnApply") }}
                      </v-btn>
                    </v-flex>

                    <!-- CURRENT ITEM EXTRA SETTINGS -->
                    <v-flex
                      xs12
                      class="ma-2"
                      style="border: 1px solid silver"
                      v-if="
                        (currentItem.rulesBackground.type == 'image' &&
                          canvasTemplate != 0 &&
                          !canvasTemplate.canvas.showSimpleFrameControls &&
                          !canvasTemplate.canvas.showTextControls &&
                          !canvasTemplate.canvas.showStickerControls &&
                          !canvasTemplate.canvas.showFrameControls) ||
                        (canvasTemplate != 0 &&
                          canvasTemplate.canvas.showSimpleFrameControls) ||
                        (canvasTemplate != 0 &&
                          canvasTemplate.canvas.showTextControls) ||
                        (canvasTemplate != 0 &&
                          canvasTemplate.canvas.showStickerControls) ||
                        (canvasTemplate != 0 &&
                          canvasTemplate.canvas.showFrameControls)
                      "
                    >
                      <div
                        class="overline px-2"
                        style="background-color: lightgray"
                      >
                        {{ $t("settingsImageTemplateCurrentItemTitle") }}
                      </div>
                      <div
                        v-if="
                          currentItem.rulesBackground.type == 'image' &&
                          !canvasTemplate.canvas.showSimpleFrameControls &&
                          !canvasTemplate.canvas.showTextControls &&
                          !canvasTemplate.canvas.showStickerControls &&
                          !canvasTemplate.canvas.showFrameControls
                        "
                      >
                        <!-- EDIT BACKGROUND IMAGE CONTROLS -->
                        <div class="d-flex ma-2">
                          <fabric-background-image-controls-card
                            :template="canvasTemplate"
                          ></fabric-background-image-controls-card>
                        </div>
                      </div>
                      <!-- EDIT SIMPLE FRAME CONTROLS -->
                      <div
                        class="d-flex ma-2"
                        v-else-if="
                          canvasTemplate.canvas.showSimpleFrameControls
                        "
                      >
                        <fabric-simple-frame-controls-card
                          :template="canvasTemplate"
                          :simpleFrameRect="
                            canvasTemplate.canvas.simpleFrameRect
                          "
                        ></fabric-simple-frame-controls-card>
                      </div>
                      <!-- EDIT TEXT CONTROLS -->
                      <div
                        class="ma-2"
                        v-else-if="canvasTemplate.canvas.showTextControls"
                      >
                        <fabric-text-controls-card
                          :template="canvasTemplate"
                        ></fabric-text-controls-card>
                        <v-flex xs12 class="mt-3">
                          <v-select
                            class="pa-0 ma-0"
                            item-text="title"
                            item-value="value"
                            v-model="templateItemExtraSettings.textFunction"
                            :items="textFunctionItems"
                            :label="$t('settingsPhotoGiftType2Title')"
                            style="height: 50px"
                            dense
                            outlined
                            @change="setTextFunction"
                          ></v-select>
                        </v-flex>
                        <v-flex xs12 class="mt-3">
                          <v-switch
                            style="height: 30px"
                            class="ma-0 pa-0"
                            v-model="templateItemExtraSettings.allowDelete"
                            :label="$t('fabricAllowDelete')"
                            @change="setAllowDelete"
                          ></v-switch>
                          <v-switch
                            style="height: 30px"
                            class="ma-0 pa-0"
                            v-model="templateItemExtraSettings.allowManipulate"
                            :label="$t('fabricAllowManipulate')"
                            @change="setAllowManipulate"
                          ></v-switch>
                          <v-switch
                            style="height: 30px"
                            class="ma-0 pa-0"
                            v-model="templateItemExtraSettings.allowEdit"
                            :label="$t('fabricAllowEdit')"
                            @change="setAllowEdit"
                          ></v-switch>
                        </v-flex>
                      </div>
                      <!-- EDIT STICKER CONTROLS -->
                      <div
                        class="d-flex ma-2"
                        v-else-if="canvasTemplate.canvas.showStickerControls"
                      >
                        <v-flex xs12>
                          <v-switch
                            style="height: 30px"
                            class="ma-0 pa-0"
                            v-model="templateItemExtraSettings.allowDelete"
                            :label="$t('fabricAllowDelete')"
                            @change="setAllowDelete"
                          ></v-switch>
                          <v-switch
                            style="height: 30px"
                            class="ma-0 pa-0"
                            v-model="templateItemExtraSettings.allowManipulate"
                            :label="$t('fabricAllowManipulate')"
                            @change="setAllowManipulate"
                          ></v-switch>
                          <v-text-field
                            v-model="templateItemExtraSettings.allowReplace"
                            :label="$t('fabricAllowReplace')"
                            :rules="[validateMaxLength(250)]"
                            :counter="250"
                            @keyup="setAllowReplace"
                          ></v-text-field>
                        </v-flex>
                      </div>
                      <!-- EDIT FRAME CONTROLS -->
                      <div
                        class="d-flex ma-2"
                        v-else-if="canvasTemplate.canvas.showFrameControls"
                      >
                        FRAME CONTROLS
                      </div>
                    </v-flex>

                    <v-flex xs12 class="ma-2" style="border: 1px solid silver">
                      <!-- BACKGROUND IMAGE MENU -->
                      <div
                        class="overline px-2"
                        style="background-color: lightgray"
                      >
                        {{ $t("settingsImageTemplateBackTitle") }}
                      </div>
                      <div class="ma-2">
                        <v-menu
                          :close-on-content-click="true"
                          offset-y
                          transition="slide-x-transition"
                        >
                          <template v-slot:activator="{ on }">
                            <v-btn
                              v-on="on"
                              middle
                              text
                              outlined
                              color="secondary"
                              class="elevation-0"
                            >
                              <v-icon class="mr-2">mdi-image</v-icon>
                              {{
                                getBackgroundTypeTitle(
                                  currentItem.rulesBackground.type
                                )
                              }}
                            </v-btn>
                          </template>
                          <v-list>
                            <!-- SELECT BACKGROUND PIXABAY IMAGE -->
                            <v-list-item
                              dense
                              class="hover-item"
                              @click="servePixabayBackgroundImageSelection()"
                            >
                              <v-list-item-icon>
                                <v-img
                                  style="width: 24px"
                                  :src="pixabayLogoSquare"
                                ></v-img>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title>{{
                                  $t(
                                    "fabricBackgroundImageAddPixabayBackgroundTitle"
                                  )
                                }}</v-list-item-title></v-list-item-content
                              >
                            </v-list-item>
                            <!-- SELECT PIXABAY PATTERN BACKGROUND -->
                            <v-list-item
                              dense
                              class="hover-item"
                              @click="servePixabayPatternImageSelection()"
                            >
                              <v-list-item-icon>
                                <v-img
                                  style="width: 24px"
                                  :src="pixabayLogoSquare"
                                ></v-img>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title>{{
                                  $t(
                                    "fabricBackgroundImageAddPixabayPatternTitle"
                                  )
                                }}</v-list-item-title></v-list-item-content
                              >
                            </v-list-item>
                            <!-- SELECT MY BACKGROUND IMAGE -->
                            <v-list-item
                              dense
                              class="hover-item"
                              @click="handlerAddNewImage()"
                            >
                              <v-list-item-icon>
                                <v-icon>mdi-upload</v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title>{{
                                  $t("fabricBackgroundImageAddImageTitle")
                                }}</v-list-item-title></v-list-item-content
                              >
                              <input
                                id="addNewImageFileInput"
                                class="d-none"
                                type="file"
                                accept="image/jpeg, image/png, image/gif, image/jpg, image/heic, image/heif"
                                @change="addNewImage"
                              />
                            </v-list-item>
                            <!-- SELECT BACKGROUND DATABASE IMAGE -->
                            <v-list-item
                              dense
                              class="hover-item"
                              @click="serveBackgroundImageSelection()"
                            >
                              <v-list-item-icon>
                                <v-icon>mdi-image-multiple</v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title>{{
                                  $t("fabricBackgroundImageAddBackgroundTitle")
                                }}</v-list-item-title></v-list-item-content
                              >
                            </v-list-item>
                            <!-- SELECT PATTERN BACKGROUND -->
                            <v-list-item
                              dense
                              class="hover-item"
                              @click="servePatternImageSelection()"
                            >
                              <v-list-item-icon>
                                <v-icon>mdi-view-grid-plus</v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title>{{
                                  $t("fabricBackgroundImageAddPatternTitle")
                                }}</v-list-item-title></v-list-item-content
                              >
                            </v-list-item>
                            <!-- SELECT COLOR BACKGROUND -->
                            <v-list-item
                              dense
                              class="hover-item"
                              @click="dialogColorPickerBack = true"
                            >
                              <v-list-item-icon>
                                <v-icon>mdi-format-color-fill</v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title>{{
                                  $t("fabricBackgroundImageAddColorTitle")
                                }}</v-list-item-title></v-list-item-content
                              >
                            </v-list-item>
                            <!-- SELECT NONE BACKGROUND -->
                            <v-list-item
                              dense
                              class="hover-item"
                              @click="
                                currentItem.rulesBackground.type = 'none';
                                setNoneBackground();
                              "
                            >
                              <v-list-item-icon>
                                <v-icon>mdi-card-off-outline</v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title>{{
                                  $t(
                                    "settingsImageTemplateBackMenuTypeNoneTitle"
                                  )
                                }}</v-list-item-title></v-list-item-content
                              >
                            </v-list-item>
                          </v-list>
                        </v-menu>
                        <div class="d-flex align-center mt-2">
                          <v-switch
                            style="height: 30px"
                            class="ma-0 pa-0 mr-2"
                            v-model="currentItem.allowTransparentBack"
                            :label="
                              $t(
                                'settingsImageTemplateGHAllowTransparentBackTitle'
                              )
                            "
                            @change="setNoneBackground"
                          ></v-switch>
                          <v-btn
                            v-show="!currentItem.allowTransparentBack"
                            text
                            middle
                            color="accent"
                            class="elevation-0 ma-0 pa-0"
                            style="min-width: 24px; width: 24px"
                            @click="dialogColorPickerActive = true"
                          >
                            <v-icon
                              :color="currentItem.transparentBackColor"
                              style="border: 1px solid silver"
                              >mdi-square</v-icon
                            >
                          </v-btn>
                        </div>
                        <v-switch
                          style="height: 25px"
                          class="ma-0 pa-0"
                          v-model="currentItem.allowBackground"
                          :label="
                            $t('settingsImageTemplateGHAllowBackgroundTitle')
                          "
                        ></v-switch>
                        <v-switch
                          v-show="currentItem.allowBackground"
                          style="height: 25px"
                          class="ma-0 pa-0"
                          v-model="currentItem.mainImageBackground"
                          :label="
                            $t(
                              'settingsImageTemplateGHMainImageBackgroundTitle'
                            )
                          "
                        ></v-switch>
                      </div>
                    </v-flex>

                    <!-- CUSTOM IMAGE PLACEHOLDERS MENU -->
                    <v-flex xs12 class="ma-2" style="border: 1px solid silver">
                      <div
                        class="overline px-2"
                        style="background-color: lightgray"
                      >
                        {{ $t("settingsImageTemplateImageTitle") }}
                      </div>
                      <div class="ma-2">
                        <v-btn
                          middle
                          text
                          outlined
                          color="secondary"
                          class="mr-2 elevation-0"
                          @click="resetCurrentItem"
                        >
                          <v-icon>mdi-restore</v-icon>
                        </v-btn>
                        <v-btn
                          middle
                          text
                          outlined
                          color="secondary"
                          class="mr-2 elevation-0"
                          @click="prepareNewCanvasItem('rect')"
                        >
                          <v-icon>mdi-plus-box</v-icon>
                        </v-btn>
                        <v-btn
                          middle
                          text
                          outlined
                          color="secondary"
                          class="mr-2 elevation-0"
                          @click="prepareNewCanvasItem('circle')"
                        >
                          <v-icon>mdi-plus-circle</v-icon>
                        </v-btn>
                      </div>
                    </v-flex>

                    <!-- MIDDLE IMAGE MENU -->
                    <v-flex xs12 class="ma-2" style="border: 1px solid silver">
                      <div
                        class="overline px-2"
                        style="background-color: lightgray"
                      >
                        {{ $t("settingsImageTemplateMiddleTitle") }}
                      </div>
                      <div class="ma-2">
                        <v-menu
                          :close-on-content-click="true"
                          offset-y
                          transition="slide-x-transition"
                        >
                          <template v-slot:activator="{ on }">
                            <v-btn
                              v-on="on"
                              middle
                              text
                              outlined
                              color="secondary"
                              class="elevation-0"
                            >
                              <v-icon class="mr-2">mdi-image</v-icon>
                              {{ getOverlayTypeTitle(currentItem.imageMgURL) }}
                            </v-btn>
                          </template>
                          <v-list>
                            <!-- SELECT MY OVERLAY IMAGE -->
                            <v-list-item
                              dense
                              class="hover-item"
                              @click="handlerAddMiddleImage()"
                            >
                              <v-list-item-icon>
                                <v-icon>mdi-upload</v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title>{{
                                  $t("fabricBackgroundImageAddImageTitle")
                                }}</v-list-item-title></v-list-item-content
                              >
                              <input
                                id="addMiddleImageFileInput"
                                class="d-none"
                                type="file"
                                accept="image/png"
                                @change="addMiddleImage"
                              />
                            </v-list-item>

                            <!-- SELECT NONE MIDDLE -->
                            <v-list-item
                              dense
                              class="hover-item"
                              @click="
                                currentItem.imageMg = '';
                                currentItem.imageMgURL = '';
                                setNoneMiddle();
                              "
                            >
                              <v-list-item-icon>
                                <v-icon>mdi-card-off-outline</v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title>{{
                                  $t(
                                    "settingsImageTemplateMiddleMenuTypeNoneTitle"
                                  )
                                }}</v-list-item-title></v-list-item-content
                              >
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </div>
                    </v-flex>

                    <!-- PERMISSIONS MENU -->
                    <v-flex xs12 class="ma-2" style="border: 1px solid silver">
                      <div
                        class="overline px-2"
                        style="background-color: lightgray"
                      >
                        {{ $t("settingsImageTemplateEditTitle") }}
                      </div>
                      <div class="ma-2">
                        <v-btn
                          middle
                          text
                          outlined
                          color="secondary"
                          class="elevation-0 mr-2"
                          @click="serveFramesSelection()"
                        >
                          <v-icon>mdi-image-outline</v-icon>
                        </v-btn>
                        <v-btn
                          middle
                          text
                          outlined
                          color="secondary"
                          class="elevation-0 mr-2"
                          @click="serveStickersSelection()"
                        >
                          <v-icon>mdi-sticker-emoji</v-icon>
                        </v-btn>
                        <v-btn
                          middle
                          text
                          outlined
                          color="secondary"
                          class="elevation-0"
                          @click="serveNewText()"
                        >
                          <v-icon>mdi-format-text-variant-outline</v-icon>
                        </v-btn>
                        <v-switch
                          style="height: 30px"
                          class="ma-0 pa-0 mt-2"
                          v-model="currentItem.allowImages"
                          :label="$t('settingsImageTemplateGHAllowImagesTitle')"
                        ></v-switch>
                        <v-switch
                          style="height: 30px"
                          class="ma-0 pa-0"
                          v-model="currentItem.allowText"
                          :label="$t('settingsImageTemplateGHAllowTextTitle')"
                        ></v-switch>
                        <v-switch
                          style="height: 30px"
                          class="ma-0 pa-0"
                          v-model="currentItem.allowFreeDrawing"
                          :label="
                            $t('settingsImageTemplateGHAllowFreeDrawingTitle')
                          "
                        ></v-switch>
                        <v-switch
                          style="height: 26px"
                          class="ma-0 pa-0"
                          v-model="currentItem.allowStickers"
                          :label="
                            $t('settingsImageTemplateGHAllowStickersTitle')
                          "
                        ></v-switch>
                      </div>
                    </v-flex>

                    <!-- OVERLAY IMAGE MENU -->
                    <v-flex xs12 class="ma-2" style="border: 1px solid silver">
                      <div
                        class="overline px-2"
                        style="background-color: lightgray"
                      >
                        {{ $t("settingsImageTemplateOverlayTitle") }}
                      </div>
                      <v-menu
                        :close-on-content-click="true"
                        offset-y
                        transition="slide-x-transition"
                      >
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-on="on"
                            middle
                            text
                            outlined
                            color="secondary"
                            class="ma-2 elevation-0"
                          >
                            <v-icon class="mr-2">mdi-image</v-icon>
                            {{ getOverlayTypeTitle(currentItem.imageFgURL) }}
                          </v-btn>
                        </template>
                        <v-list>
                          <!-- SELECT MY OVERLAY IMAGE -->
                          <v-list-item
                            dense
                            class="hover-item"
                            @click="handlerAddOverlayImage()"
                          >
                            <v-list-item-icon>
                              <v-icon>mdi-upload</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title>{{
                                $t("fabricBackgroundImageAddImageTitle")
                              }}</v-list-item-title></v-list-item-content
                            >
                            <input
                              id="addOverlayImageFileInput"
                              class="d-none"
                              type="file"
                              accept="image/png"
                              @change="addOverlayImage"
                            />
                          </v-list-item>

                          <!-- SELECT NONE OVERLAY -->
                          <v-list-item
                            dense
                            class="hover-item"
                            @click="
                              currentItem.imageFg = '';
                              currentItem.imageFgURL = '';
                              setNoneOverlay();
                            "
                          >
                            <v-list-item-icon>
                              <v-icon>mdi-card-off-outline</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title>{{
                                $t(
                                  "settingsImageTemplateOverlayMenuTypeNoneTitle"
                                )
                              }}</v-list-item-title></v-list-item-content
                            >
                          </v-list-item>
                        </v-list>
                      </v-menu>
                      <v-switch
                        v-show="currentItem.imageFgURL != ''"
                        style="height: 30px"
                        class="ma-0 pa-0 ml-3 mb-1"
                        v-model="currentItem.removeOverlay"
                        :label="$t('fabricRemoveOverlay')"
                      ></v-switch>
                    </v-flex>
                  </v-flex>

                  <!-- CANVAS -->
                  <div
                    id="canvasEditTemplate"
                    class="d-flex"
                    style="width: 100%"
                  >
                    <v-spacer></v-spacer>
                    <canvas
                      ref="fabricEditTemplate"
                      style="object-fit: contain; border: 1px solid forestgreen"
                    ></canvas>
                    <v-spacer></v-spacer>
                  </div>
                </v-card-text>

                <v-card-actions
                  :class="
                    getTheme() == 'dark' ? '#505050--text' : '#505050--text'
                  "
                  :style="
                    getTheme() == 'dark'
                      ? 'background-color: whitesmoke; border-top: 1px solid lightgray;'
                      : 'background-color: white; border-top: 1px solid lightgray;'
                  "
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    class="my-1 mr-5"
                    text
                    @click="
                      dialogEditTemplate = false;
                      refresh();
                    "
                    >{{ $t("addEditFormCancelButton") }}</v-btn
                  >
                  <v-btn
                    @click="saveEditTemplate"
                    color="primary"
                    dark
                    class="ml-5"
                  >
                    <v-icon medium class="mr-1">mdi-content-save</v-icon>
                    {{ $t("addEditFormSaveButton") }}
                  </v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-dialog>

          <!-- DIALOG VUE CROPPER BASIC -->
          <dialog-vue-cropper-basic
            v-model="showCropper"
            :cropperItem="cropperItem"
            :viewMode="1"
            :scaleFactor="1"
            @croppedImage="setNewDBBackground($event.image)"
          ></dialog-vue-cropper-basic>

          <!-- DIALOG VUE CROPPER MIDDLE -->
          <dialog-vue-cropper-basic
            v-model="showCropperMiddle"
            :cropperItem="cropperItem"
            :viewMode="1"
            :scaleFactor="1"
            @croppedImage="setNewMiddleImage($event.image)"
            png
          ></dialog-vue-cropper-basic>

          <!-- DIALOG VUE CROPPER OVERLAY -->
          <dialog-vue-cropper-basic
            v-model="showCropperOverlay"
            :cropperItem="cropperItem"
            :viewMode="1"
            :scaleFactor="1"
            @croppedImage="setNewOverlayImage($event.image)"
            png
          ></dialog-vue-cropper-basic>

          <!-- DIALOG COLOR PICKER ALLOW TRANSPARENT BACKGROUND -->
          <dialog-color-picker
            :active="dialogColorPickerActive"
            @clickYes="dialogColorPickerActive = false"
            icon="mdi-palette"
            :title="$t('fabricColorPickerTitle')"
            :initColor="
              !currentItem.transparentBackColor
                ? '#FFFFFFFF'
                : currentItem.transparentBackColor
            "
            @selectedColor="
              currentItem.transparentBackColor = $event;
              setNoneBackground();
            "
          ></dialog-color-picker>

          <!-- DIALOG COLOR PICKER BACKGROUND COLOR -->
          <dialog-color-picker
            :active="dialogColorPickerBack"
            @clickYes="dialogColorPickerBack = false"
            icon="mdi-palette"
            :title="$t('fabricColorPickerTitle')"
            :gradient="
              !currentItem.rulesBackground.colorGradient
                ? true
                : currentItem.rulesBackground.colorGradient
            "
            @gradientChecked="
              currentItem.rulesBackground.colorGradient = $event;
              refreshBackground();
            "
            :initColor="
              !currentItem.rulesBackground.color
                ? '#FFFFFFFF'
                : currentItem.rulesBackground.color
            "
            @selectedColor="
              currentItem.rulesBackground.color = $event;
              currentItem.rulesBackground.type = 'color';
              refreshBackground();
            "
          ></dialog-color-picker>

          <!-- PIXABAY IMAGE SELECTION DIALOG -->
          <dialog-background-image-selection
            v-model="showPixabayBackgroundSelection"
            startPixabaySearch=""
            @selectedItem="addFromImageDBPixabay($event)"
          ></dialog-background-image-selection>

          <!-- PIXABAY PATTERN SELECTION DIALOG -->
          <dialog-background-image-selection
            v-model="showPixabayBackgroundPatternSelection"
            startPixabaySearch="seamless"
            @selectedItem="addFromImageDBPixabayPattern($event)"
          ></dialog-background-image-selection>

          <!-- IMAGE DATABASE LIVE SELECTION DIALOG -->
          <dialog-image-database-live-selection
            v-model="showImageDatabaseLiveSelection"
            mode="edit"
            order="add"
            :dType="dType"
            :dTitle="dTitle"
            :dIcon="dIcon"
            :pageSize="25"
            @selectedItem="addFromImageDB($event)"
          ></dialog-image-database-live-selection>

          <v-snackbar
            v-model="$store.state.storeSnackbar.snackbar.active"
            :color="$store.state.storeSnackbar.snackbar.color"
            :timeout="$store.state.storeSnackbar.snackbar.timeout"
            >{{ $store.state.storeSnackbar.snackbar.message }}</v-snackbar
          >
        </v-layout>
      </div>
    </v-main>
  </v-container>
</template>

<script>
import firebase from "firebase/app";
import "firebase/functions";
import * as c from "@/constants";
import AppNavigation from "@/views/AppNavigation";
import MainSubPageToolbar from "@/components/MainSubPageToolbar";
import DialogBasicYesNo from "@/components/DialogBasicYesNo";
import DialogColorPicker from "@/components/DialogColorPicker";
import SimpleNavigationButton from "@/components/SimpleNavigationButton";
import DialogBackgroundImageSelection from "@/components/DialogBackgroundImageSelection";
import DialogImageDatabaseLiveSelection from "@/components/DialogImageDatabaseLiveSelection";
import DataTableSearchToolbar from "@/components/DataTableSearchToolbar";
import DialogVueCropperBasic from "@/components/DialogVueCropperBasic";
import FabricTextControlsCard from "@/components/FabricTextControlsCard";
import FabricSimpleFrameControlsCard from "@/components/FabricSimpleFrameControlsCard";
import FabricBackgroundImageControlsCard from "@/components/FabricBackgroundImageControlsCard";
import { lightenDarkenColor } from "@/mixins/utils";
import * as fabricJs from "@/mixins/modFabricJsHelper";
import { fabric } from "fabric";
import "fabric-customise-controls";
import { v4 as uuidv4 } from "uuid";
import { storage } from "@/firebase";
import {
  readAndRotateUrlFile,
  readNewUrlFile,
  readNewSimpleExtraFile,
  resizeImage,
} from "@/mixins/modPhotoOrderUploadService";
import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
} from "tiptap-vuetify";

export default {
  name: "settingsImageTemplate",
  components: {
    TiptapVuetify,
    AppNavigation,
    MainSubPageToolbar,
    DialogBasicYesNo,
    FabricTextControlsCard,
    FabricBackgroundImageControlsCard,
    SimpleNavigationButton,
    DataTableSearchToolbar,
    DialogImageDatabaseLiveSelection,
    DialogColorPicker,
    DialogVueCropperBasic,
    FabricSimpleFrameControlsCard,
    DialogBackgroundImageSelection,
  },
  data() {
    return {
      extensions: [
        History,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [
          Heading,
          {
            options: {
              levels: [1, 2, 3, 4, 5, 6],
            },
          },
        ],
        Bold,
        Code,
        HorizontalRule,
        Paragraph,
        HardBreak,
      ],
      pixabayLogoSquare: require("@/assets/pixabay.svg"),
      transparentBack: require("@/assets/transparent-back.png"),
      deleteIconSVG: require("@/assets/delete-icon.svg"),
      resizeIconTR: require("@/assets/resize-icon-tr.svg"),
      resizeIconTL: require("@/assets/resize-icon-tl.svg"),
      resizeIconBR: require("@/assets/resize-icon-br.svg"),
      resizeIconBL: require("@/assets/resize-icon-bl.svg"),
      resizeIconMR: require("@/assets/resize-icon-mr.svg"),
      resizeIconMT: require("@/assets/resize-icon-mt.svg"),
      resizeIconMB: require("@/assets/resize-icon-mb.svg"),
      resizeIconML: require("@/assets/resize-icon-ml.svg"),
      maximizeIcon: require("@/assets/maximize-icon.svg"),
      editIconSVG: require("@/assets/edit-icon.svg"),
      rotateIconSVG: require("@/assets/rotate-icon.svg"),
      dialogColorPickerActive: false,
      dialogColorPickerBack: false,
      valid: true,
      validRules: true,
      netBackImage: require("@/assets/netBack.png"),
      defaultImage: require("@/assets/giftCategoryDefault.jpg"),
      search: "",
      showImageDatabaseLiveSelection: false,
      dType: "",
      dTitle: "",
      dIcon: "",
      showCropper: false,
      showCropperOverlay: false,
      showCropperMiddle: false,
      canvasRatio: 1,
      dialog: false,
      showPixabayBackgroundSelection: false,
      showPixabayBackgroundPatternSelection: false,
      dialogEditTemplate: false,
      dialogDelete: false,
      dialogDeleteId: "",
      dialogDeleteImageFg: false,
      dialogWait: false,
      canvasTemplate: 0,
      originalItemType: "", // shranimo za preverjanje ob shranjevanju templatea
      originalItemImageBgURL: "", // shranimo za preverjanje ob shranjevanju templatea
      originalItemImageFgURL: "", // shranimo za preverjanje ob shranjevanju templatea
      originalItemImageMgURL: "", // shranimo za preverjanje ob shranjevanju templatea
      originalItemRulesBackground: {},
      originalItem: {},
      textFunctionItems: [
        {
          title: this.$t("fabricTextFunctionNormal"),
          value: 0,
        },
        {
          title: this.$t("fabricTextFunctionGiftCardFull"),
          value: 10,
        },
        {
          title: this.$t("fabricTextFunctionGiftCardFullShort"),
          value: 15,
        },
        {
          title: this.$t("fabricTextFunctionGiftCardCodeValidTo"),
          value: 20,
        },
        {
          title: this.$t("fabricTextFunctionGiftCardCodeValidToShort"),
          value: 25,
        },
        {
          title: this.$t("fabricTextFunctionGiftCardFullCode"),
          value: 30,
        },
        {
          title: this.$t("fabricTextFunctionGiftCardFullPrice"),
          value: 40,
        },
        {
          title: this.$t("fabricTextFunctionGiftCardFullValidTo"),
          value: 50,
        },
        {
          title: this.$t("fabricTextFunctionGiftCardCode"),
          value: 60,
        },
        {
          title: this.$t("fabricTextFunctionGiftCardPrice"),
          value: 70,
        },
        {
          title: this.$t("fabricTextFunctionGiftCardPriceOnly"),
          value: 75,
        },
        {
          title: this.$t("fabricTextFunctionGiftCardValidTo"),
          value: 80,
        },
      ],
      currentItem: {
        rulesBackground: {
          type: "none",
          color: "#FFFFFFFF",
          colorGradient: true,
        },
        rulesSimple: [],
        rulesFrames: [],
        rulesStickers: [],
        rulesText: [],
      },
      cropperItem: {
        aspectRatio: 0,
        tempBackImage: "",
        tempMiddleImage: "",
        tempOverlayImage: "",
        image: "",
      },
      headers: [
        {
          text: this.$t("settingsImageTemplateGridHeaderOrderTitle"),
          align: "center",
          value: "order",
          sortable: true,
        },
        {
          text: this.$t("settingsImageTemplateGridHeaderCodeTitle"),
          align: "center",
          value: "code",
          sortable: true,
        },
        {
          text: this.$t("settingsImageTemplateGridHeaderTitleTitle"),
          align: "left",
          value: "title",
          sortable: true,
        },
        {
          text: this.$t(
            "settingsImageTemplateGridHeaderPreviewImageShortTitle"
          ),
          align: "left",
          value: "previewImage",
        },
        {
          text: this.$t("settingsImageTemplateKeywordsTitle"),
          align: "center",
          value: "keywords",
        },
        {
          text: this.$t("settingsImageTemplateGridHeaderEditedTimestampTitle"),
          align: "center",
          value: "editedTimestamp",
        },
        {
          text: this.$t("settingsImageTemplateGridHeaderCreatedTimestampTitle"),
          align: "center",
          value: "createdTimestamp",
        },
        {
          text: this.$t("settingsImageTemplateGridHeaderPrivateTitle"),
          align: "center",
          value: "private",
          sortable: true,
        },
        {
          text: this.$t("settingsImageTemplateGridHeaderActiveTitle"),
          align: "center",
          value: "active",
          sortable: true,
        },
        {
          text: "",
          align: "center",
          sortable: false,
          value: "actions",
        },
        {
          text: this.$t("msgMore"),
          value: "data-table-expand",
        },
      ],
      editedIndex: -1,
      editedItem: {
        order: 1,
        client: this.$store.state.storeClient.client.basicSettings.name,
        code: "",
        title: "",
        description: "",
        instructions: "",
        keywords: "",
        module: this.$route.params.subPath,
        language: this.$store.state.storeClient.client.environmentSettings.lang,
        active: true,
        private: true,
        allowTransparentBack: true,
        transparentBackColor: "#FFFFFFFF",
        mainImageBackground: false,
        allowAutoPreview: true,
        allowBackground: true,
        allowImages: true,
        allowText: true,
        allowStickers: true,
        allowFreeDrawing: true,
        removeOverlay: false,
        createdTimestamp: new Date(),
        editedTimestamp: new Date(),
        previewImage: [],
        previewImageURL: "",
        rules: "",
        rulesBackground: {},
        rulesFrames: [],
        rulesStickers: [],
        rulesSimple: [],
        rulesText: [],
        imagePr: "",
        imagePrURL: "",
        imageBg: "",
        imageBgURL: "",
        imageFg: "",
        imageFgURL: "",
        imageMg: "",
        imageMgURL: "",
        width: 1000,
        height: 1000,
      },
      defaultItem: {
        order: 1,
        client: this.$store.state.storeClient.client.basicSettings.name,
        code: "",
        title: "",
        description: "",
        instructions: "",
        keywords: "",
        module: this.$route.params.subPath,
        language: this.$store.state.storeClient.client.environmentSettings.lang,
        active: true,
        private: true,
        allowTransparentBack: true,
        transparentBackColor: "#FFFFFFFF",
        mainImageBackground: false,
        allowAutoPreview: true,
        allowBackground: true,
        allowImages: true,
        allowText: true,
        allowStickers: true,
        allowFreeDrawing: true,
        removeOverlay: false,
        createdTimestamp: new Date(),
        editedTimestamp: new Date(),
        previewImage: [],
        previewImageURL: "",
        rules: "",
        rulesBackground: {},
        rulesFrames: [],
        rulesStickers: [],
        rulesSimple: [],
        rulesText: [],
        imagePr: "",
        imagePrURL: "",
        imageBg: "",
        imageBgURL: "",
        imageFg: "",
        imageFgURL: "",
        imageMg: "",
        imageMgURL: "",
        width: 1000,
        height: 1000,
      },
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? this.$t("addEditFormAddingTitle")
        : this.$t("addEditFormEditingTitle");
    },
  },
  methods: {
    doCommand(e) {
      if (this.dialogEditTemplate) {
        // do stuff
        let movementDelta = 1;
        if (e.shiftKey) {
          movementDelta = 20;
        }

        switch (e.keyCode) {
          case 37:
            e.preventDefault(); // Prevent the default action
            if (this.canvasTemplate.canvas.getActiveObject()) {
              this.canvasTemplate.canvas
                .getActiveObject()
                .set(
                  "left",
                  this.canvasTemplate.canvas.getActiveObject().get("left") -
                    movementDelta
                );
            } else if (this.canvasTemplate.canvas.getActiveGroup()) {
              this.canvasTemplate.canvas
                .getActiveGroup()
                .set(
                  "left",
                  this.canvasTemplate.canvas.getActiveGroup().get("left") -
                    movementDelta
                );
            }
            break;
          case 38:
            e.preventDefault(); // Prevent the default action
            if (this.canvasTemplate.canvas.getActiveObject()) {
              this.canvasTemplate.canvas
                .getActiveObject()
                .set(
                  "top",
                  this.canvasTemplate.canvas.getActiveObject().get("top") -
                    movementDelta
                );
            } else if (this.canvasTemplate.canvas.getActiveGroup()) {
              this.canvasTemplate.canvas
                .getActiveGroup()
                .set(
                  "top",
                  this.canvasTemplate.canvas.getActiveGroup().get("top") -
                    movementDelta
                );
            }
            break;
          case 39:
            e.preventDefault(); // Prevent the default action
            if (this.canvasTemplate.canvas.getActiveObject()) {
              this.canvasTemplate.canvas
                .getActiveObject()
                .set(
                  "left",
                  this.canvasTemplate.canvas.getActiveObject().get("left") +
                    movementDelta
                );
            } else if (this.canvasTemplate.canvas.getActiveGroup()) {
              this.canvasTemplate.canvas
                .getActiveGroup()
                .set(
                  "left",
                  this.canvasTemplate.canvas.getActiveGroup().get("left") +
                    movementDelta
                );
            }
            break;
          case 40:
            e.preventDefault(); // Prevent the default action
            if (this.canvasTemplate.canvas.getActiveObject()) {
              this.canvasTemplate.canvas
                .getActiveObject()
                .set(
                  "top",
                  this.canvasTemplate.canvas.getActiveObject().get("top") +
                    movementDelta
                );
            } else if (this.canvasTemplate.canvas.getActiveGroup()) {
              this.canvasTemplate.canvas
                .getActiveGroup()
                .set(
                  "top",
                  this.canvasTemplate.canvas.getActiveGroup().get("top") +
                    movementDelta
                );
            }
            break;
        }

        if (this.canvasTemplate.canvas.getActiveObject()) {
          this.canvasTemplate.canvas.getActiveObject().setCoords();
          this.canvasTemplate.canvas.requestRenderAll();
        } else if (this.canvasTemplate.canvas.getActiveGroup()) {
          this.canvasTemplate.canvas.getActiveGroup().setCoords();
          this.canvasTemplate.canvas.requestRenderAll();
        }
      }
    },

    async toggleImageTemplateBooleanActive(item) {
      try {
        await this.$store.dispatch("toggleImageTemplateBooleanActive", item);
      } catch (error) {
        this.$store.commit({
          type: "showSnackbar",
          color: "error",
          message: error,
        });
        return;
      }
    },
    async toggleImageTemplateBooleanPrivate(item) {
      try {
        await this.$store.dispatch("toggleImageTemplateBooleanPrivate", item);
      } catch (error) {
        this.$store.commit({
          type: "showSnackbar",
          color: "error",
          message: error,
        });
        return;
      }
    },
    setTextFunction() {
      this.canvasTemplate.canvas
        .getActiveObject()
        .set("textFunction", this.templateItemExtraSettings.textFunction);
    },
    setAllowEdit() {
      this.canvasTemplate.canvas
        .getActiveObject()
        .set("allowEdit", this.templateItemExtraSettings.allowEdit);
    },
    setAllowDelete() {
      this.canvasTemplate.canvas
        .getActiveObject()
        .set("allowDelete", this.templateItemExtraSettings.allowDelete);
    },
    setAllowManipulate() {
      this.canvasTemplate.canvas
        .getActiveObject()
        .set("allowManipulate", this.templateItemExtraSettings.allowManipulate);
    },
    setAllowReplace() {
      this.canvasTemplate.canvas
        .getActiveObject()
        .set("allowReplace", this.templateItemExtraSettings.allowReplace);
    },
    servePixabayBackgroundImageSelection() {
      this.canvasRatio = this.currentItem.width / this.currentItem.height;
      this.showPixabayBackgroundSelection = true;
    },
    servePixabayPatternImageSelection() {
      this.showPixabayBackgroundPatternSelection = true;
    },
    serveBackgroundImageSelection() {
      //console.log("currentItem", this.currentItem);
      this.canvasRatio = this.currentItem.width / this.currentItem.height;
      this.dType = c.G_IMAGE_DATABASE_TYPE_BACKGROUNDS;
      this.dTitle = this.$t("fabricSelectImageBackgoundDialogTitle");
      this.dIcon = "mdi-image-multiple";
      this.showImageDatabaseLiveSelection = true;
    },
    servePatternImageSelection() {
      this.canvasRatio = this.currentItem.width / this.currentItem.height;
      this.dType = c.G_IMAGE_DATABASE_TYPE_PATTERNS;
      this.dTitle = this.$t("fabricBackgroundImageAddPatternTitle");
      this.dIcon = "mdi-view-grid-plus";
      this.showImageDatabaseLiveSelection = true;
    },
    serveStickersSelection() {
      this.canvasRatio = this.currentItem.width / this.currentItem.height;
      this.dType = c.G_IMAGE_DATABASE_TYPE_STICKERS;
      this.dTitle = this.$t("fabricSelectStickerDialogTitle");
      this.dIcon = "mdi-sticker-emoji";
      this.showImageDatabaseLiveSelection = true;
    },
    serveFramesSelection() {
      this.canvasRatio = this.currentItem.width / this.currentItem.height;
      this.dType = c.G_IMAGE_DATABASE_TYPE_FRAMES;
      this.dTitle = this.$t("fabricSelectStickerDialogTitle");
      this.dIcon = "mdi-sticker-emoji";
      this.showImageDatabaseLiveSelection = true;
    },
    serveNewText() {
      const _original_initHiddenTextarea =
        fabric.IText.prototype.initHiddenTextarea;
      fabric.util.object.extend(
        fabric.IText.prototype,
        /** @lends fabric.IText.prototype */ {
          //fix for : IText not editable when canvas is in a fullscreen element on chrome
          // https://github.com/fabricjs/fabric.js/issues/5126
          initHiddenTextarea: function () {
            _original_initHiddenTextarea.call(this);
            this.canvas.wrapperEl.appendChild(this.hiddenTextarea);
          },
        }
      );

      fabricJs.addTemplateText(
        this.canvasTemplate,
        this.canvasTemplate,
        {
          textFunction: 0,
          allowDelete: false,
          allowManipulate: false,
          allowEdit: false,
        },
        this.fonts,
        this.textBrushes,
        this.textBrush,
        this.$t("msgEditText"),
        this.$vuetify.breakpoint,
        true,
        true
      );
    },
    setNewOverlayImage(image) {
      this.canvasTemplate.canvas.setOverlayImage(
        image,
        this.canvasTemplate.canvas.requestRenderAll.bind(
          this.canvasTemplate.canvas
        ),
        {
          //globalCompositeOperation: "destination-out",
          originX: "left",
          originY: "top",
          crossOrigin: "*",
          opacity: 1,
          selectable: false,
          evented: false,
        }
      );
      this.cropperItem.tempOverlayImage = image;
      this.currentItem.imageFgURL = "tainted";
    },
    setNewMiddleImage(image) {
      this.setNoneMiddle();
      let vm = this;
      fabric.Image.fromURL(
        image,
        function (img) {
          let img1 = img.set({
            myType: "middleImage",
            evented: false,
            selectable: false,
            originX: "left",
            originY: "top",
            opacity: 1,
          });

          vm.canvasTemplate.canvas.insertAt(img1, 0).requestRenderAll();
        },
        { crossOrigin: "*" }
      );

      this.cropperItem.tempMiddleImage = image;
      this.currentItem.imageMgURL = "tainted";
    },
    setNewDBBackground(image) {
      let vm = this;
      fabric.Image.fromURL(
        image,
        function (img) {
          vm.canvasTemplate.canvas.setBackgroundImage(img);
          vm.canvasTemplate.canvas.requestRenderAll();

          vm.canvasTemplate.canvas.transparentBack = false;
          vm.canvasTemplate.canvas.backgroundColor = "#00000000";

          vm.canvasTemplate.canvas.backgroundImageBrightness = 0; // reset svetlosti ozadja
          vm.canvasTemplate.canvas.backgroundImageContrast = 0; // reset kontrasta ozadja
          vm.canvasTemplate.canvas.backgroundImageBlur = 0; // reset blur ozadja
          vm.canvasTemplate.canvas.backgroundImageFilter = 0; // reset filtra ozadja

          vm.currentItem.rulesBackground.type = "image";
          vm.cropperItem.tempBackImage = image;
        },
        {
          // Needed to position backgroundImage at 0/0
          originX: "left",
          originY: "top",
          crossOrigin: "*",
        }
      );
    },
    addFromImageDBPixabay(image) {
      this.showPixabayBackgroundSelection = false;

      this.cropperItem.aspectRatio =
        Number(this.currentItem.width) / Number(this.currentItem.height);
      this.cropperItem.image = image;
      this.cropperItem.width = Number(this.currentItem.width);
      this.cropperItem.height = Number(this.currentItem.height);

      this.showCropper = true;
    },
    addFromImageDBPixabayPattern(image) {
      this.showPixabayBackgroundPatternSelection = false;
      this.dialogWait = true;

      let vm = this;
      this.canvasTemplate.canvas.setBackgroundColor(
        { source: image, repeat: "repeat", crossOrigin: "*" },
        function () {
          vm.canvasTemplate.canvas.backgroundImage = 0;
          vm.canvasTemplate.transparentBack = false;
          vm.currentItem.rulesBackground.type = "pattern";

          vm.currentItem.imageBg = image;
          vm.currentItem.imageBgURL = image;

          vm.canvasTemplate.canvas.requestRenderAll();
          vm.dialogWait = false;
        }
      );
    },
    addFromImageDB(item) {
      if (this.dType == c.G_IMAGE_DATABASE_TYPE_STICKERS) {
        this.showImageDatabaseLiveSelection = false;
        fabricJs.addTemplateSticker(
          item,
          this.currentItem,
          this.canvasTemplate,
          this.$vuetify.breakpoint,
          true
        );
      } else if (this.dType == c.G_IMAGE_DATABASE_TYPE_BACKGROUNDS) {
        this.showImageDatabaseLiveSelection = false;
        // če je točna dimazija izbrane slike, potem ne pokažemo cropperja
        if (
          item.width == this.currentItem.width &&
          item.height == this.currentItem.height
        ) {
          readNewUrlFile(item).then((img) => {
            //console.log(img);
            this.setNewDBBackground(img.image.path);
          });
        } else {
          this.cropperItem.aspectRatio =
            Number(this.currentItem.width) / Number(this.currentItem.height);
          this.cropperItem.image = item.image;
          this.cropperItem.width = Number(this.currentItem.width);
          this.cropperItem.height = Number(this.currentItem.height);

          // če se ozadje ne ujema po orientaciji, ga obrnemo, če ima rotate: true v bazi
          if (
            ((item.aRatio > 1 && this.cropperItem.aspectRatio <= 1) ||
              (item.aRatio <= 1 && this.cropperItem.aspectRatio > 1)) &&
            item.rotate &&
            this.cropperItem.aspectRatio != 1
          ) {
            let vm = this;
            readAndRotateUrlFile(item, false).then((img) => {
              vm.cropperItem.image = img.path;
              vm.showCropper = true;
            });
          } else {
            this.showCropper = true;
          }
        }
      } else if (this.dType == c.G_IMAGE_DATABASE_TYPE_PATTERNS) {
        this.showImageDatabaseLiveSelection = false;
        //console.log(item);
        let vm = this;
        this.canvasTemplate.canvas.setBackgroundColor(
          { source: item.image, repeat: "repeat", crossOrigin: "*" },
          function () {
            vm.canvasTemplate.canvas.backgroundImage = 0;
            vm.canvasTemplate.canvas.transparentBack = false;
            vm.currentItem.rulesBackground.type = "pattern";
            vm.currentItem.imageBg = item.image;
            vm.currentItem.imageBgURL = item.imageURL;
            vm.canvasTemplate.canvas.requestRenderAll();
          }
        );
      } else if (this.dType == c.G_IMAGE_DATABASE_TYPE_FRAMES) {
        //console.log("ADD FRAMESSSSS");
        this.showImageDatabaseLiveSelection = false;
        fabricJs.addTemplateFrame(
          item,
          this.currentItem,
          this.canvasTemplate,
          true,
          this.$vuetify.breakpoint,
          true,
          false
        );
      }
    },
    handlerAddMiddleImage() {
      document.getElementById("addMiddleImageFileInput").click();
    },
    addMiddleImage(e) {
      readNewSimpleExtraFile(e.target.files[0]).then((img) => {
        // če je točna dimezija izbrane slike, potem ne pokažemo cropperja
        if (
          img.image.attr.width == this.currentItem.width &&
          img.image.attr.width == this.currentItem.width
        ) {
          this.setNewMiddleImage(img.image.path);
        } else {
          this.cropperItem.aspectRatio =
            Number(this.currentItem.width) / Number(this.currentItem.height);
          this.cropperItem.image = img.image.path;
          this.cropperItem.width = Number(this.currentItem.width);
          this.cropperItem.height = Number(this.currentItem.height);
          this.showCropperMiddle = true;
        }
      });
    },
    handlerAddOverlayImage() {
      document.getElementById("addOverlayImageFileInput").click();
    },
    addOverlayImage(e) {
      readNewSimpleExtraFile(e.target.files[0]).then((img) => {
        // če je točna dimezija izbrane slike, potem ne pokažemo cropperja
        if (
          img.image.attr.width == this.currentItem.width &&
          img.image.attr.width == this.currentItem.width
        ) {
          this.setNewOverlayImage(img.image.path);
        } else {
          this.cropperItem.aspectRatio =
            Number(this.currentItem.width) / Number(this.currentItem.height);
          this.cropperItem.image = img.image.path;
          this.cropperItem.width = Number(this.currentItem.width);
          this.cropperItem.height = Number(this.currentItem.height);
          this.showCropperOverlay = true;
        }
      });
    },
    handlerAddNewImage() {
      document.getElementById("addNewImageFileInput").click();
    },
    addNewImage(e) {
      readNewSimpleExtraFile(e.target.files[0]).then((img) => {
        // če je točna dimazija izbrane slike, potem ne pokažemo cropperja
        if (
          img.image.attr.width == this.currentItem.width &&
          img.image.attr.height == this.currentItem.height
        ) {
          this.setNewDBBackground(img.image.path);
        } else {
          this.cropperItem.aspectRatio =
            Number(this.currentItem.width) / Number(this.currentItem.height);
          this.cropperItem.image = img.image.path;
          this.cropperItem.width = Number(this.currentItem.width);
          this.cropperItem.height = Number(this.currentItem.height);
          this.showCropper = true;
        }
      });
    },
    setNoneOverlay() {
      this.canvasTemplate.canvas.setOverlayImage(
        null,
        this.canvasTemplate.canvas.requestRenderAll.bind(
          this.canvasTemplate.canvas
        )
      );
      this.cropperItem.tempOverlayImage = "";
      this.currentItem.imageFgURL = "";
      console.log("setNoneOverlay");
    },
    setNoneMiddle() {
      //console.log(this.canvasTemplate.canvas.getItemsByMyType("middleImage"));
      this.canvasTemplate.canvas.remove(
        this.canvasTemplate.canvas.getItemsByMyType("middleImage")[0]
      );
      this.canvasTemplate.canvas.requestRenderAll();
      this.cropperItem.tempMiddleImage = "";
      this.currentItem.imageMg = "";
      this.currentItem.imageMgURL = "";
      console.log("setNoneMiddle");
    },
    setNoneBackground() {
      if (this.currentItem.rulesBackground.type == "none") {
        this.canvasTemplate.canvas.backgroundImage = 0;

        if (this.currentItem.allowTransparentBack) {
          let vm = this;
          this.canvasTemplate.canvas.setBackgroundColor(
            { source: this.transparentBack, repeat: "repeat" },
            function () {
              vm.canvasTemplate.canvas.requestRenderAll();
            }
          );
        } else {
          this.canvasTemplate.canvas.backgroundColor =
            this.currentItem.transparentBackColor;
          this.canvasTemplate.canvas.requestRenderAll();
        }
      }
    },
    getBackgroundTypeTitle(title) {
      if (title == "none") {
        return this.$t("settingsImageTemplateBackTypeNone");
      } else if (title == "image") {
        return this.$t("settingsImageTemplateBackTypeImage");
      } else if (title == "pattern") {
        return this.$t("settingsImageTemplateBackTypePattern");
      } else if (title == "color") {
        return this.$t("settingsImageTemplateBackTypeColor");
      } else return "";
    },
    getOverlayTypeTitle(title) {
      if (title == "") {
        return this.$t("settingsImageTemplateBackTypeNone");
      } else return this.$t("settingsImageTemplateBackTypeImage");
    },
    getBooleanIcon(val) {
      return val ? "mdi-check-bold" : "mdi-close-circle-outline";
    },
    getColor(val) {
      if (val) return "success";
    },
    deleteItemSet(item) {
      this.dialogDelete = true;
      this.dialogDeleteId = item;
    },
    async deleteItem() {
      try {
        await this.$store.dispatch("removeImageTemplate", this.dialogDeleteId);
        this.dialogDelete = false;
        this.dialogDeleteId = "";

        this.$store.commit({
          type: "showSnackbar",
          color: "success",
          message: this.$t("msgSuccessDelete"),
        });
      } catch (error) {
        this.dialogDelete = false;
        this.dialogDeleteId = "";

        this.$store.commit({
          type: "showSnackbar",
          color: "error",
          message: error,
        });
        return;
      }
    },
    copyItem(item) {
      item.rules = "";
      (item.rulesBackground = {
        type: "none",
      }),
        (item.previewImage = []);
      item.previewImageURL = "";
      item.imageBg = "";
      item.imageBgURL = "";
      item.imageFg = "";
      item.imageFgURL = "";
      item.imageMg = "";
      item.imageMgURL = "";
      item.imagePr = "";
      item.imagePrURL = "";
      item.allowTransparentBack = true;
      item.transparentBackColor = "#FFFFFFFF";
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    editItem(item) {
      this.editedIndex =
        this.$store.state.storeImageTemplate.imageTemplate.indexOf(item);
      item.previewImage2 = item.previewImage; // duplikat, da ne izgine slika v prikazu baze
      item.previewImage = [];
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    initEditRules(item) {
      this.originalItem = Object.assign({}, item);
      this.originalItemType = item.rulesBackground.type;
      this.originalItemImageBgURL = item.imageBgURL;
      this.originalItemImageFgURL = item.imageFgURL;
      this.originalItemImageMgURL = item.imageMgURL;

      console.log("originalItemInit", this.originalItem);
      this.editRules(item);
    },
    resetCurrentItem() {
      console.log("originalItemReset", this.originalItem);
      this.editRules(
        Object.assign(this.originalItem, {
          width: this.currentItem.width,
          height: this.currentItem.height,
        })
      );
    },
    prepareNewCanvasItem(mode) {
      this.addNewCanvasItem(
        {
          clipP: mode,
          width: this.canvasTemplate.width / 3,
          height:
            mode == "circle"
              ? this.canvasTemplate.width / 3
              : this.canvasTemplate.height / 3,
          top: this.canvasTemplate.height / 2,
          left: this.canvasTemplate.width / 2,
          angle: 0,
          stroke: this.simpleFrameBorderSettings.borderColor,
          strokeWidth: this.simpleFrameBorderSettings.borderWidth,
          borderRadius: this.simpleFrameBorderSettings.borderRadius,
        },
        true
      );
    },
    addMiddleImageToCanvas() {
      // eslint-disable-next-line
      return new Promise((resolve, reject) => {
        let vm = this;
        fabric.Image.fromURL(
          this.currentItem.imageMg,
          function (img) {
            let img1 = img.set({
              myType: "middleImage",
              selectable: false,
              evented: false,
              originX: "left",
              originY: "top",
              opacity: 1,
            });
            console.log("add middle image");
            resolve(vm.canvasTemplate.canvas.add(img1).requestRenderAll());
          },
          { crossOrigin: "*" }
        );
      });
    },
    addNewCanvasItem(x, setActive) {
      console.log(x);
      // eslint-disable-next-line
      return new Promise((resolve, reject) => {
        let rectangle;

        if (x.clipP == "rect") {
          rectangle = new fabric.Rect({
            myType: "templatePlaceholder",
            clipP: x.clipP,
            width: Number(x.width) - Number(x.strokeWidth),
            height: Number(x.height) - Number(x.strokeWidth),
            top: Number(x.top),
            left: Number(x.left),
            angle: Number(x.angle),
            originX: "center",
            originY: "center",
            rx: Number(x.borderRadius),
            ry: Number(x.borderRadius),
            fill: "rgba(100,200,200,0.35)",
            stroke: x.stroke,
            strokeWidth: Number(x.strokeWidth),
          });
        } else
          rectangle = new fabric.Ellipse({
            myType: "templatePlaceholder",
            clipP: x.clipP,
            top: Number(x.top),
            left: Number(x.left),
            rx: Number(x.width) / 2 - Number(x.strokeWidth) / 2,
            ry: Number(x.height) / 2 - Number(x.strokeWidth) / 2,
            angle: Number(x.angle),
            originX: "center",
            originY: "center",
            fill: "rgba(100,200,200,0.35)",
            stroke: x.stroke,
            strokeWidth: Number(x.strokeWidth),
          });

        rectangle.setControlsVisibility({
          tl: true,
          tr: true,
          bl: true,
          br: true,
          ml: true,
          mt: true,
          mr: true,
          mb: true,
          mtr: true,
        });

        rectangle.set({
          centeredScaling: false,
          rotatingPointOffset: this.canvasTemplate.width / 25,
          borderColor: "rgba(255,0,0,0.5)",
          cornerSize: this.$vuetify.breakpoint.smAndUp
            ? this.canvasTemplate.width / 50
            : this.canvasTemplate.width / 12,
          cornerShape: "rect",
          cornerStrokeColor: "rgba(0,0,0,0)",
          borderScaleFactor: this.canvasTemplate.width / 200,
          transparentCorners: true,
        });

        rectangle.on("selected", function () {
          fabric.Canvas.prototype.customiseControls({
            bl: {
              action: "remove",
              cursor: "pointer",
            },
            br: {
              action: "scale",
              cursor: "resize",
            },
            tl: {
              action: "scale",
              cursor: "resize",
            },
            tr: {
              action: "scale",
              cursor: "resize",
            },
            ml: {
              cursor: "pointer",
              action: function (e, target) {
                target.sendToBack(true);
                console.log("item sent backward.");
              },
            },
            mt: {
              cursor: "pointer",
              action: function (e, target) {
                target.bringToFront(true);
                console.log("item brought forward.");
              },
            },
            mr: {
              action: "scaleX",
              cursor: "resize",
            },
            mb: {
              action: "scaleY",
              cursor: "resize",
            },
          });
        });

        rectangle.customiseCornerIcons({
          tl: {
            icon: this.resizeIconTL,
          },
          tr: {
            icon: this.resizeIconTR,
          },
          bl: {
            icon: this.deleteIconSVG,
          },
          br: {
            icon: this.resizeIconBR,
          },
          ml: {
            icon: require("@/assets/down-arrow.svg"),
          },
          mt: {
            icon: require("@/assets/up-arrow.svg"),
          },
          mr: {
            icon: this.resizeIconMR,
          },
          mb: {
            icon: this.resizeIconMB,
          },
          // only is hasRotatingPoint is not set to false
          mtr: {
            icon: this.rotateIconSVG,
          },
        });

        /*if (x.clipP == "circle") {
          rectangle.clipPath = new fabric.Ellipse({
            top: -Number(x.height) / 2,
            left: -Number(x.width) / 2,
            rx: Number(x.width) / 2,
            ry: Number(x.height) / 2,
          });
        }*/

        if (setActive) {
          // Render in canvas in propper layer order position
          let c = 0;
          this.canvasTemplate.canvas.forEachObject((x) => {
            if (
              x.myType != "middleImage" &&
              x.myType != "frame" &&
              x.myType != "templateFrame" &&
              x.myType != "templateFramePlaceholder" &&
              x.myType != "sticker" &&
              x.myType != "text" &&
              x.myType != "freeDrawing"
            )
              c++;
          });

          resolve(
            this.canvasTemplate.canvas
              .insertAt(rectangle, c <= 0 ? 0 : c - 1)
              .requestRenderAll()
          );
        } else {
          resolve(this.canvasTemplate.canvas.add(rectangle).requestRenderAll());
        }

        console.log("==> ELEMENT ADDED.");
      });
    },
    async loadCanvasElements() {
      // pridobimo realni width
      let rw =
        document.getElementById("canvasEditTemplate").offsetWidth /
        this.canvasTemplate.cRatio;
      // pridobimo realni height
      let rh =
        document.getElementById("canvasEditTemplate").offsetHeight /
        (this.canvasTemplate.height / this.canvasTemplate.width);

      if (this.canvasTemplate.width < rw && this.canvasTemplate.height < rh) {
        this.canvasTemplate.canvas.setDimensions(
          {
            width: this.canvasTemplate.width + "px",
            height: this.canvasTemplate.height + "px",
          },
          { cssOnly: true }
        );
      } else if (
        document.getElementById("canvasEditTemplate").offsetHeight <= rw
      ) {
        // če je potreben scroll potem nastavimo višino kot glavno stranico za prikaz
        this.canvasTemplate.canvas.setDimensions(
          {
            width: rh + "px",
            height: "100%",
          },
          { cssOnly: true }
        );
      }
      // sicer izrišemo glavno stranico kot width
      // dodamo še izračunani height
      else
        this.canvasTemplate.canvas.setDimensions(
          { width: "100%", height: rw + "px" },
          { cssOnly: true }
        );

      // morebitni elementi
      await Promise.all(
        this.canvasTemplate.items.map(async (x) => {
          await this.addNewCanvasItem(x, false);
        })
      );
      console.log("END ELEMENTS");

      // LOAD MIDDLE LAYER
      if (this.currentItem.imageMgURL != "") {
        await this.addMiddleImageToCanvas();
      }

      // morebitni okvirji
      await Promise.all(
        this.currentItem.rulesFrames.map(async (x) => {
          console.log("LOOP FRAME START");
          await fabricJs.addTemplateFrame(
            x,
            this.currentItem,
            this.canvasTemplate,
            true,
            this.$vuetify.breakpoint,
            false,
            x.rotated
          );
          console.log("LOOP FRAME END");
        })
      );

      // morebitne nalepke
      await Promise.all(
        this.currentItem.rulesStickers.map(async (x) => {
          await fabricJs.addTemplateSticker(
            x,
            this.currentItem,
            this.canvasTemplate,
            this.$vuetify.breakpoint,
            false
          );
        })
      );

      // morebitno besedilo
      await Promise.all(
        this.currentItem.rulesText.map(async (x) => {
          await fabricJs.addTemplateText(
            this.canvasTemplate,
            this.currentItem,
            x,
            this.fonts,
            this.textBrushes,
            this.textBrush,
            x.text,
            this.$vuetify.breakpoint,
            false,
            true
          );
        })
      );

      // help grid
      let gridSizeX = this.canvasTemplate.width / 4;
      let gridSizeY = this.canvasTemplate.height / 4;
      let gridoption = {
        stroke: "#00000080",
        strokeWidth: 2,
        strokeDashArray: [15, 15],
      };
      let gridLines = [];
      //console.log(this.canvasTemplate.width, this.canvasTemplate.height);
      for (let i = Math.ceil(this.canvasTemplate.width / gridSizeX); i--; ) {
        gridLines.push(
          new fabric.Line([gridSizeX * i, 0, gridSizeX * i, 5000], gridoption)
        );
      }
      for (let i = Math.ceil(this.canvasTemplate.height / gridSizeY); i--; ) {
        gridLines.push(
          new fabric.Line([0, gridSizeY * i, 5000, gridSizeY * i], gridoption)
        );
      }
      let gridGroup = new fabric.Group(gridLines, {
        selectable: false,
        evented: false,
        myType: "helpGrid",
      });
      gridGroup.addWithUpdate();
      this.canvasTemplate.canvas.insertAt(gridGroup, 0);

      this.canvasTemplate.canvas.requestRenderAll();
    },
    refreshBackground() {
      // LOAD BACKGROUND LAYER
      if (this.currentItem.rulesBackground.type == "none") {
        if (this.currentItem.allowTransparentBack) {
          let vm = this;
          this.canvasTemplate.canvas.backgroundImage = 0;
          this.canvasTemplate.canvas.setBackgroundColor(
            { source: this.transparentBack, repeat: "repeat" },
            function () {
              vm.canvasTemplate.canvas.requestRenderAll();
            }
          );
        } else {
          this.canvasTemplate.canvas.backgroundImage = 0;
          this.canvasTemplate.canvas.backgroundColor =
            this.currentItem.transparentBackColor;
          this.canvasTemplate.canvas.requestRenderAll();
        }
      } else if (this.currentItem.rulesBackground.type == "color") {
        this.canvasTemplate.canvas.backgroundImage = 0;

        if (this.currentItem.rulesBackground.colorGradient) {
          this.canvasTemplate.canvas.backgroundColor =
            this.currentItem.rulesBackground.color;
          let transpose =
            "#" +
            lightenDarkenColor(
              this.currentItem.rulesBackground.color.substring(1, 7),
              -40
            ) +
            "FF";
          if (transpose.length <= 7)
            transpose = "#00" + transpose.substring(1, 7);
          console.log("transpose", transpose);
          this.canvasTemplate.canvas.setBackgroundColor(
            new fabric.Gradient({
              type: "radial",
              coords: {
                r1: 360,
                r2: this.canvasTemplate.canvas.width / 2,
                x1: this.canvasTemplate.canvas.width / 2,
                y1: this.canvasTemplate.canvas.height / 2,
                x2: this.canvasTemplate.canvas.width / 2,
                y2: this.canvasTemplate.canvas.height / 2,
              },
              colorStops: [
                {
                  color:
                    "rgba(" +
                    parseInt(
                      this.currentItem.rulesBackground.color.substring(1, 3),
                      16
                    ) +
                    ", " +
                    parseInt(
                      this.currentItem.rulesBackground.color.substring(3, 5),
                      16
                    ) +
                    ", " +
                    parseInt(
                      this.currentItem.rulesBackground.color.substring(5, 7),
                      16
                    ) +
                    ", " +
                    Math.trunc(
                      (parseInt(
                        this.currentItem.rulesBackground.color.substring(7, 9),
                        16
                      ) *
                        100) /
                        255
                    ) /
                      100 +
                    ")",
                  offset: 0,
                },
                {
                  color:
                    "rgba(" +
                    parseInt(transpose.substring(1, 3), 16) +
                    ", " +
                    parseInt(transpose.substring(3, 5), 16) +
                    ", " +
                    parseInt(transpose.substring(5, 7), 16) +
                    ", " +
                    Math.trunc(
                      (parseInt(transpose.substring(7, 9), 16) * 100) / 255
                    ) /
                      100 +
                    ")",
                  offset: 1,
                },
              ],
            })
          );
        } else
          this.canvasTemplate.canvas.backgroundColor =
            this.currentItem.rulesBackground.color;

        this.canvasTemplate.canvas.requestRenderAll();
      } else if (this.currentItem.rulesBackground.type == "pattern") {
        let vm = this;
        this.canvasTemplate.canvas.setBackgroundColor(
          { source: this.currentItem.imageBg, repeat: "repeat" },
          function () {
            vm.canvasTemplate.canvas.backgroundImage = 0;
            vm.canvasTemplate.canvas.transparentBack = false;
            vm.canvasTemplate.canvas.requestRenderAll();
          }
        );
      } else if (this.currentItem.rulesBackground.type == "image") {
        let vm = this;
        fabric.Image.fromURL(
          this.currentItem.imageBg,
          function (img) {
            vm.canvasTemplate.canvas.setBackgroundImage(img);
            vm.canvasTemplate.canvas.requestRenderAll();

            vm.canvasTemplate.canvas.transparentBack = false;
            vm.canvasTemplate.canvas.backgroundColor = "#00000000";

            // apply saved filter settings
            fabricJs.changeBackgroundImageFilter(vm.canvasTemplate, true);
            fabricJs.changeBackgroundImageBrightness(vm.canvasTemplate);
            fabricJs.changeBackgroundImageBlur(vm.canvasTemplate);
            fabricJs.changeBackgroundImageContrast(vm.canvasTemplate);
          },
          {
            // Needed to position backgroundImage at 0/0
            originX: "left",
            originY: "top",
            crossOrigin: "*",
          }
        );
      }

      // LOAD OVERLAY LAYER
      if (this.currentItem.imageFgURL != "")
        this.canvasTemplate.canvas.setOverlayImage(
          this.currentItem.imageFg,
          this.canvasTemplate.canvas.requestRenderAll.bind(
            this.canvasTemplate.canvas
          ),
          {
            //globalCompositeOperation: "destination-out",
            originX: "left",
            originY: "top",
            crossOrigin: "*",
            opacity: 1,
            selectable: false,
            evented: false,
          }
        );
    },
    editRules(item) {
      this.currentItem = Object.assign({}, item);

      // kasneje dodanim lastnostim v bazi moramo še dodati vrednost, če še ne obstajajo
      "removeOverlay" in this.currentItem
        ? ""
        : (this.currentItem.removeOverlay = false);

      this.currentItem.rulesBackground = Object.assign(
        {},
        item.rulesBackground
      );

      if (this.canvasTemplate.canvas) this.canvasTemplate.canvas.dispose();
      this.canvasTemplate = {};
      let itemPrintItemsTemp = []; // uporabnikove slike

      // če je velikost pravilno vnešena, prikažemo template
      if (item.width > 0 && item.height > 0) {
        this.dialogEditTemplate = true;

        // ali imamo tudi definirane simple slike?
        this.currentItem.rulesSimple = this.currentItem.rulesSimple
          ? item.rulesSimple
          : [];

        // če imamo shranjeno na nov način uporabimo novega, sicer pa beremo iz rules
        if (this.currentItem.rulesSimple.length > 0) {
          this.currentItem.rulesSimple.forEach((y) => {
            itemPrintItemsTemp.push({
              left: y.left,
              top: y.top,
              width: y.width,
              height: y.height,
              angle: y.angle,
              clipP: y.clipP,
              strokeWidth: y.strokeWidth,
              stroke: y.stroke,
              borderRadius: y.borderRadius,
              ready: false,
            });
          });
        } else if (item.rules.length > 0) {
          let a2 = item.rules.split("|");

          a2.forEach((y) => {
            let y1 = y.split(",");
            itemPrintItemsTemp.push({
              left: y1[0],
              top: y1[1],
              width: y1[2],
              height: y1[3],
              angle: y1[4],
              clipP: y1[5],
              strokeWidth: y1[6],
              stroke: y1[7],
              borderRadius: y1[8],
              ready: false,
            });
          });
        }

        this.canvasTemplate.width = item.width;
        this.canvasTemplate.height = item.height;
        this.canvasTemplate.cRatio = item.width / item.height;
        this.canvasTemplate.items = itemPrintItemsTemp;

        // ustvarimo nov fabricCanvas
        this.canvasTemplate.canvas = new fabric.Canvas(
          this.$refs.fabricEditTemplate,
          {
            width: this.canvasTemplate.width,
            height: this.canvasTemplate.height,
            selection: false,
            enableRetinaScaling: false,
            renderOnAddRemove: true,
            showTextControls: false,
            showSimpleFrameControls: false,
            showStickerControls: false,
            showFrameControls: false,
            simpleFrameRect: false,
            showBackgroundImageControls:
              item.rulesBackground.type == "image" ? true : false,
            backgroundImageBrightness: item.rulesBackground.imageBrightness
              ? item.rulesBackground.imageBrightness
              : 0,
            backgroundImageBlur: item.rulesBackground.imageBlur
              ? item.rulesBackground.imageBlur
              : 0,
            backgroundImageContrast: item.rulesBackground.imageContrast
              ? item.rulesBackground.imageContrast
              : 0,
            backgroundImageFilter: item.rulesBackground.imageFilter
              ? item.rulesBackground.imageFilter
              : 0,
            //showFillBackControls: false
          }
        );

        let vm = this;
        this.canvasTemplate.canvas.on("object:removed", function () {
          vm.canvasTemplate.canvas.showTextControls = false;
          vm.canvasTemplate.canvas.showSimpleFrameControls = false;
          vm.canvasTemplate.canvas.showStickerControls = false;
          vm.canvasTemplate.canvas.showFrameControls = false;

          vm.templateItemExtraSettings.textFunction = 0;
          vm.templateItemExtraSettings.allowDelete = false;
          vm.templateItemExtraSettings.allowManipulate = false;
          vm.templateItemExtraSettings.allowEdit = false;
          vm.templateItemExtraSettings.allowReplace = "";
          vm.$forceUpdate();
        });

        this.canvasTemplate.canvas.on("object:selected", function (e) {
          if (e.target.myType == "text") {
            vm.canvasTemplate.canvas.showTextControls = true;
            vm.canvasTemplate.canvas.showSimpleFrameControls = false;
            vm.canvasTemplate.canvas.showStickerControls = false;
            vm.canvasTemplate.canvas.showFrameControls = false;

            vm.templateItemExtraSettings.textFunction = e.target.textFunction;
            vm.templateItemExtraSettings.allowDelete = e.target.allowDelete;
            vm.templateItemExtraSettings.allowManipulate =
              e.target.allowManipulate;
            vm.templateItemExtraSettings.allowEdit = e.target.allowEdit;
          } else if (e.target.myType == "templatePlaceholder") {
            if (e.target.type == "rect") {
              vm.canvasTemplate.canvas.simpleFrameRect = true;
            } else {
              vm.canvasTemplate.canvas.simpleFrameRect = false;
            }
            vm.canvasTemplate.canvas.showSimpleFrameControls = true;
            vm.canvasTemplate.canvas.showTextControls = false;
            vm.canvasTemplate.canvas.showStickerControls = false;
            vm.canvasTemplate.canvas.showFrameControls = false;
          } else if (e.target.myType == "sticker") {
            vm.canvasTemplate.canvas.showTextControls = false;
            vm.canvasTemplate.canvas.showSimpleFrameControls = false;
            vm.canvasTemplate.canvas.showStickerControls = true;
            vm.canvasTemplate.canvas.showFrameControls = false;

            vm.templateItemExtraSettings.allowDelete = e.target.allowDelete;
            vm.templateItemExtraSettings.allowManipulate =
              e.target.allowManipulate;
            vm.templateItemExtraSettings.allowReplace = e.target.allowReplace;
          } else if (e.target.myType == "templateFrame") {
            vm.canvasTemplate.canvas.showTextControls = false;
            vm.canvasTemplate.canvas.showSimpleFrameControls = false;
            vm.canvasTemplate.canvas.showStickerControls = false;
            vm.canvasTemplate.canvas.showFrameControls = true;
          }
          console.log("Object selected.");
          vm.$forceUpdate();
        });

        this.canvasTemplate.canvas.on("selection:cleared", function () {
          vm.canvasTemplate.canvas.showTextControls = false;
          vm.canvasTemplate.canvas.showSimpleFrameControls = false;
          vm.canvasTemplate.canvas.showStickerControls = false;
          vm.canvasTemplate.canvas.showFrameControls = false;

          vm.templateItemExtraSettings.textFunction = 0;
          vm.templateItemExtraSettings.allowDelete = false;
          vm.templateItemExtraSettings.allowManipulate = false;
          vm.templateItemExtraSettings.allowEdit = false;
          vm.templateItemExtraSettings.allowReplace = "";

          console.log("Selection cleared.");
          vm.$forceUpdate();
        });

        this.canvasTemplate.canvas.on("selection:updated", function (e) {
          if (e.target.myType == "text") {
            vm.canvasTemplate.canvas.showTextControls = true;
            vm.canvasTemplate.canvas.showSimpleFrameControls = false;
            vm.canvasTemplate.canvas.showStickerControls = false;
            vm.canvasTemplate.canvas.showFrameControls = false;

            vm.templateItemExtraSettings.textFunction = e.target.textFunction;
            vm.templateItemExtraSettings.allowDelete = e.target.allowDelete;
            vm.templateItemExtraSettings.allowManipulate =
              e.target.allowManipulate;
            vm.templateItemExtraSettings.allowEdit = e.target.allowEdit;
          } else if (e.target.myType == "templatePlaceholder") {
            if (e.target.type == "rect") {
              vm.canvasTemplate.canvas.simpleFrameRect = true;
            } else {
              vm.canvasTemplate.canvas.simpleFrameRect = false;
            }
            vm.canvasTemplate.canvas.showSimpleFrameControls = true;
            vm.canvasTemplate.canvas.showTextControls = false;
            vm.canvasTemplate.canvas.showStickerControls = false;
            vm.canvasTemplate.canvas.showFrameControls = false;
          } else if (e.target.myType == "templateFrame") {
            vm.canvasTemplate.canvas.showSimpleFrameControls = false;
            vm.canvasTemplate.canvas.showTextControls = false;
            vm.canvasTemplate.canvas.showStickerControls = false;
            vm.canvasTemplate.canvas.showFrameControls = true;
          } else if (e.target.myType == "sticker") {
            vm.canvasTemplate.canvas.showSimpleFrameControls = false;
            vm.canvasTemplate.canvas.showTextControls = false;
            vm.canvasTemplate.canvas.showStickerControls = true;
            vm.canvasTemplate.canvas.showFrameControls = false;

            vm.templateItemExtraSettings.allowDelete = e.target.allowDelete;
            vm.templateItemExtraSettings.allowManipulate =
              e.target.allowManipulate;
            vm.templateItemExtraSettings.allowReplace = e.target.allowReplace;
          }
          console.log("Selection updated.", e.target.myType);
          vm.$forceUpdate();
        });

        this.refreshBackground();

        // preberemo morebitne opise okvirjev in jih dodamo na template
        this.currentItem.rulesFrames = this.currentItem.rulesFrames
          ? item.rulesFrames
          : [];

        // preberemo morebitne opise nalepk in jih dodamo na template
        this.currentItem.rulesStickers = this.currentItem.rulesStickers
          ? item.rulesStickers
          : [];

        // preberemo morebitne opise besedil in jih dodamo na template
        this.currentItem.rulesText = this.currentItem.rulesText
          ? item.rulesText
          : [];

        setTimeout(() => {
          this.loadCanvasElements();
        }, 500);

        // najprej uveljavimo dimenzije za width, da bomo potem lahko izračunali še height
        this.canvasTemplate.canvas.setDimensions(
          { width: "100%", height: "1px" },
          { cssOnly: true }
        );

        //console.log(a1[0] + "x" + a1[1]);
        //console.log(this.canvasTemplate);
      } else {
        this.$store.commit({
          type: "showSnackbar",
          color: "error",
          message: this.$t("settingsImageTemplateErrorWrongDimensions"),
        });
      }
    },
    refresh() {
      this.dialog = false;

      this.$store.dispatch("getImageTemplate", {
        client: this.$store.state.storeClient.client.basicSettings.name,
        startFilter: this.$store.state.storeImageTemplate.filterSubTemplate,
        module: this.$route.params.subPath,
        private: true,
      });
    },
    close() {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    },
    async saveEditTemplate() {
      if (this.$refs.formRules.validate()) {
        // HANDLE ADDED SIMPLE FRAMES
        this.currentItem.rulesSimple = [];
        this.canvasTemplate.canvas.getObjects().filter((o) => {
          if (o.get("type") == "rect" || o.get("type") == "ellipse") {
            this.currentItem.rulesSimple.push({
              clipP: o.clipP,
              left: o.left,
              top: o.top,
              width: o.getScaledWidth(),
              height: o.getScaledHeight(),
              angle: o.angle,
              strokeWidth: o.strokeWidth,
              stroke: o.stroke,
              borderRadius: o.get("type") == "rect" ? o.rx : 0,
            });
          }
        });

        // HANDLE ADDED FRAMES
        this.currentItem.rulesFrames = [];
        this.canvasTemplate.canvas
          .getItemsByMyType("templateFrame")
          .forEach((x) => {
            this.currentItem.rulesFrames.push({
              id: x.id,
              image: x.image,
              left: x.left,
              top: x.top,
              angle: x.angle,
              scaleX: x.scaleX,
              scaleY: x.scaleY,
              coordinates: x.coordinates,
              width: x.myWidth,
              height: x.myHeight,
              rotated: x.myRotated,
              rotate: x.myRotate,
            });
          });
        this.currentItem.rulesFrames.reverse();

        // HANDLE ADDED STICKERS
        this.currentItem.rulesStickers = [];
        this.canvasTemplate.canvas.getItemsByMyType("sticker").forEach((x) => {
          this.currentItem.rulesStickers.push({
            id: x.id,
            image: x.image,
            left: x.left,
            top: x.top,
            angle: x.angle,
            scaleX: x.scaleX,
            scaleY: x.scaleY,
            allowDelete: x.allowDelete,
            allowManipulate: x.allowManipulate,
            allowReplace: x.allowReplace,
          });
        });

        // HANDLE ADDED TEXT
        this.currentItem.rulesText = [];
        this.canvasTemplate.canvas.getItemsByMyType("text").forEach((x) => {
          this.currentItem.rulesText.push({
            text: x.text,
            left: x.left,
            top: x.top,
            angle: x.angle,
            scaleX: x.scaleX,
            scaleY: x.scaleY,
            fontSize: x.fontSize,
            fontText: this.fonts.indexOf(x.fontFamily),
            textColor: x.fill,
            textColorBackground: x.backgroundColor,
            shadowText: x.strokeWidth,
            shadowTextColor: x.stroke,
            textFunction: x.textFunction,
            allowDelete: x.allowDelete,
            allowManipulate: x.allowManipulate,
            allowEdit: x.allowEdit,
          });
        });
        this.dialogEditTemplate = false;
        this.dialogWait = true;

        const promises = [];
        console.log("this.originalItemType =>", this.originalItemType);
        console.log(
          "this.currentItem.rulesBackground.type =>",
          this.currentItem.rulesBackground.type
        );

        // HANDLE BACKGROUND IMAGE LAYER
        if (
          this.currentItem.rulesBackground.type == "none" ||
          this.currentItem.rulesBackground.type == "color"
        ) {
          if (this.originalItemType == "image") {
            // če nimamo slike za ozadje, morebitno obstoječo izbrišemo iz baze
            let deleteImage = firebase
              .functions()
              .httpsCallable("deleteImageFromStorage");
            await deleteImage([this.originalItemImageBgURL]);
            console.log("DELETE => 1");
          }
          this.currentItem.imageBg = "";
          this.currentItem.imageBgURL = "";
        } else if (this.currentItem.rulesBackground.type == "pattern") {
          if (this.originalItemType == "image") {
            // če nimamo slike za ozadje, morebitno obstoječo izbrišemo iz baze
            let deleteImage = firebase
              .functions()
              .httpsCallable("deleteImageFromStorage");
            await deleteImage([this.originalItemImageBgURL]);
            console.log("DELETE => 2");
          } else {
            //console.log("BACKGROUND => NO CHANGE");
          }
        } else if (this.currentItem.rulesBackground.type == "image") {
          if (this.cropperItem.tempBackImage.length > 0) {
            //console.log("BACKGROUND => FULL replace FULL");
            // izbrano sliko za ozadje zamenjamo oziroma dodamo v storage
            let imageBgUploadPath = "";
            if (
              this.currentItem.imageBgURL.length > 0 &&
              this.currentItem.imageBgURL.split("/")[0] == "imageTemplates"
            ) {
              imageBgUploadPath = this.currentItem.imageBgURL;
            } else {
              imageBgUploadPath =
                "imageTemplates/" + this.currentItem.client + "-" + uuidv4();
              this.currentItem.imageBgURL = imageBgUploadPath;
            }

            let imageBgStorageRef = storage.ref(imageBgUploadPath);
            let imageBgUploadTask = imageBgStorageRef.putString(
              this.cropperItem.tempBackImage,
              "data_url"
            );
            promises.push(imageBgUploadTask);

            let vm = this;
            imageBgUploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, {
              complete: function () {
                imageBgUploadTask.snapshot.ref
                  .getDownloadURL()
                  .then(function (downloadURL) {
                    vm.currentItem.imageBg = downloadURL;
                    vm.currentItem.rulesBackground.imageFilter =
                      vm.canvasTemplate.canvas.backgroundImageFilter == 0
                        ? 0
                        : vm.canvasTemplate.canvas.backgroundImageFilter - 1; // -1 damo, da pride prav
                    vm.currentItem.rulesBackground.imageBrightness =
                      vm.canvasTemplate.canvas.backgroundImageBrightness;
                    vm.currentItem.rulesBackground.imageContrast =
                      vm.canvasTemplate.canvas.backgroundImageContrast;
                    vm.currentItem.rulesBackground.imageBlur =
                      vm.canvasTemplate.canvas.backgroundImageBlur;
                    //console.log("BACKGROUND => UPLOADED / update filters");
                  });
              },
            });
          } else {
            this.currentItem.rulesBackground.imageFilter =
              this.canvasTemplate.canvas.backgroundImageFilter == 0
                ? 0
                : this.canvasTemplate.canvas.backgroundImageFilter - 1; // -1 damo, da pride prav
            this.currentItem.rulesBackground.imageBrightness =
              this.canvasTemplate.canvas.backgroundImageBrightness;
            this.currentItem.rulesBackground.imageContrast =
              this.canvasTemplate.canvas.backgroundImageContrast;
            this.currentItem.rulesBackground.imageBlur =
              this.canvasTemplate.canvas.backgroundImageBlur;
            //console.log("BACKGROUND => NO CHANGE / update filters");
          }
        } else {
          //console.log("BACKGROUND => NO CHANGE");
        }

        // HANDLE MIDDLE IMAGE LAYER
        if (
          this.originalItemImageMgURL != "" &&
          this.currentItem.imageMgURL != "" &&
          this.cropperItem.tempMiddleImage != ""
        ) {
          //console.log("MIDDLE => FULL replace FULL");
          let imageMgUploadPath = this.originalItemImageMgURL;
          this.currentItem.imageMgURL = imageMgUploadPath;

          let imageMgStorageRef = storage.ref(imageMgUploadPath);
          let imageMgUploadTask = imageMgStorageRef.putString(
            this.cropperItem.tempMiddleImage,
            "data_url"
          );
          promises.push(imageMgUploadTask);

          let vm = this;
          imageMgUploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, {
            complete: function () {
              imageMgUploadTask.snapshot.ref
                .getDownloadURL()
                .then(function (downloadURL) {
                  vm.currentItem.imageMg = downloadURL;
                });
            },
          });
        } else if (
          this.originalItemImageMgURL != "" &&
          this.currentItem.imageMgURL == ""
        ) {
          let deleteImage = firebase
            .functions()
            .httpsCallable("deleteImageFromStorage");
          let res = await deleteImage([this.originalItemImageMgURL]);
          //console.log("DELETE => 3");

          if (res.data == "OK") {
            this.currentItem.imageMg = "";
            this.currentItem.imageMgURL = "";
          }
        } else if (
          this.originalItemImageMgURL == "" &&
          this.currentItem.imageMgURL != ""
        ) {
          //console.log("MIDDLE => EMPTY copy to FULL");
          let imageMgUploadPath =
            "imageTemplates/" + this.currentItem.client + "-" + uuidv4();
          this.currentItem.imageMgURL = imageMgUploadPath;

          let imageMgStorageRef = storage.ref(imageMgUploadPath);
          let imageMgUploadTask = imageMgStorageRef.putString(
            this.cropperItem.tempMiddleImage,
            "data_url"
          );
          promises.push(imageMgUploadTask);

          let vm = this;
          imageMgUploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, {
            complete: function () {
              imageMgUploadTask.snapshot.ref
                .getDownloadURL()
                .then(function (downloadURL) {
                  vm.currentItem.imageMg = downloadURL;
                });
            },
          });
        } else if (
          this.originalItemImageMgURL == "" &&
          this.currentItem.imageMgURL == ""
        ) {
          //console.log("MIDDLE => EMPTY to EMPTY");
          this.currentItem.imageMg = "";
          this.currentItem.imageMgURL = "";
        }

        // HANDLE OVERLAY IMAGE LAYER
        if (
          this.originalItemImageFgURL != "" &&
          this.currentItem.imageFgURL != "" &&
          this.cropperItem.tempOverlayImage != ""
        ) {
          //console.log("OVERLAY => FULL replace FULL");
          let imageFgUploadPath = this.originalItemImageFgURL;
          this.currentItem.imageFgURL = imageFgUploadPath;

          let imageFgStorageRef = storage.ref(imageFgUploadPath);
          let imageFgUploadTask = imageFgStorageRef.putString(
            this.cropperItem.tempOverlayImage,
            "data_url"
          );
          promises.push(imageFgUploadTask);

          let vm = this;
          imageFgUploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, {
            complete: function () {
              imageFgUploadTask.snapshot.ref
                .getDownloadURL()
                .then(function (downloadURL) {
                  vm.currentItem.imageFg = downloadURL;
                });
            },
          });
        } else if (
          this.originalItemImageFgURL != "" &&
          this.currentItem.imageFgURL == ""
        ) {
          let deleteImage = firebase
            .functions()
            .httpsCallable("deleteImageFromStorage");
          let res = await deleteImage([this.originalItemImageFgURL]);
          //console.log("DELETE => 4");

          if (res.data == "OK") {
            this.currentItem.imageFg = "";
            this.currentItem.imageFgURL = "";
          }
        } else if (
          this.originalItemImageFgURL == "" &&
          this.currentItem.imageFgURL != ""
        ) {
          //console.log("OVERLAY => EMPTY copy to FULL");
          let imageFgUploadPath =
            "imageTemplates/" + this.currentItem.client + "-" + uuidv4();
          this.currentItem.imageFgURL = imageFgUploadPath;

          let imageFgStorageRef = storage.ref(imageFgUploadPath);
          let imageFgUploadTask = imageFgStorageRef.putString(
            this.cropperItem.tempOverlayImage,
            "data_url"
          );
          promises.push(imageFgUploadTask);

          let vm = this;
          imageFgUploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, {
            complete: function () {
              imageFgUploadTask.snapshot.ref
                .getDownloadURL()
                .then(function (downloadURL) {
                  vm.currentItem.imageFg = downloadURL;
                });
            },
          });
        } else if (
          this.originalItemImageFgURL == "" &&
          this.currentItem.imageFgURL == ""
        ) {
          //console.log("OVERLAY => EMPTY to EMPTY");
          this.currentItem.imageFg = "";
          this.currentItem.imageFgURL = "";
        }

        await Promise.all(promises);

        //console.log("Promises resolved.");
        //console.log(this.currentItem);

        // remove grid for auto preview generation
        this.canvasTemplate.canvas.getItemsByMyType("helpGrid").forEach((x) => {
          this.canvasTemplate.canvas.remove(x);
        });

        // pomanjšamo canvas za predogled, izračunamo height glede na dani width 400
        let autoPreviewImage = await resizeImage(
          this.canvasTemplate.canvas.toDataURL(
            {
              format: "jpeg",
              quality: c.G_FILE_COMPRESSION,
            },
            250,
            250
          )
        );

        // shranimo auto preview
        const promises2 = [];
        if (this.currentItem.imagePrURL == "") {
          this.currentItem.imagePrURL =
            "imageTemplates/" + this.currentItem.client + "-" + uuidv4();
        }

        let imagePrStorageRef = storage.ref(this.currentItem.imagePrURL);
        let imagePrUploadTask = imagePrStorageRef.putString(
          autoPreviewImage,
          "data_url"
        );
        promises2.push(imagePrUploadTask);

        let vm = this;
        imagePrUploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, {
          complete: function () {
            imagePrUploadTask.snapshot.ref
              .getDownloadURL()
              .then(function (downloadURL) {
                vm.currentItem.imagePr = downloadURL;
              });
          },
        });

        await Promise.all(promises2);

        setTimeout(() => {
          try {
            this.$store.dispatch("saveImageTemplateRules", this.currentItem);
            this.$store.commit({
              type: "showSnackbar",
              color: "success",
              message: this.$t("msgSuccessEdit"),
            });
          } catch (error) {
            this.$store.commit({
              type: "showSnackbar",
              color: "error",
              message: error,
            });
          }

          this.dialogWait = false;
        }, 2000);
      }
    },
    async save() {
      if (this.$refs.form.validate()) {
        this.dialog = false;
        this.dialogWait = true;
        if (this.editedIndex > -1) {
          try {
            if (Array.isArray(this.editedItem.previewImage)) {
              delete this.editedItem.previewImage;
            }
            await this.$store.dispatch("editImageTemplate", this.editedItem);
            await this.$store.dispatch("getImageTemplate", {
              client: this.$store.state.storeClient.client.basicSettings.name,
              startFilter:
                this.$store.state.storeImageTemplate.filterSubTemplate,
              module: this.$route.params.subPath,
              private: true,
            });
            this.dialogWait = false;

            this.$store.commit({
              type: "showSnackbar",
              color: "success",
              message: this.$t("msgSuccessEdit"),
            });
          } catch (error) {
            this.dialogWait = false;
            this.$store.commit({
              type: "showSnackbar",
              color: "error",
              message: error,
            });
          }
        } else {
          try {
            if (Array.isArray(this.editedItem.previewImage))
              delete this.editedItem.previewImage;

            await this.$store.dispatch("addImageTemplate", this.editedItem);
            await this.$store.dispatch("getImageTemplate", {
              client: this.$store.state.storeClient.client.basicSettings.name,
              startFilter:
                this.$store.state.storeImageTemplate.filterSubTemplate,
              module: this.$route.params.subPath,
              private: true,
            });
            this.dialogWait = false;

            this.$store.commit({
              type: "showSnackbar",
              color: "success",
              message: this.$t("msgSuccessAdd"),
            });
          } catch (error) {
            this.dialogWait = false;
            this.$store.commit({
              type: "showSnackbar",
              color: "error",
              message: error,
            });
          }
        }
        this.close();
      }
    },
  },
  created() {
    window.addEventListener("keydown", this.doCommand);
    //console.log(this.$store.state.storeImageTemplate.filterSubTemplate);

    this.$store.dispatch("getImageTemplate", {
      client: this.$store.state.storeClient.client.basicSettings.name,
      module: this.$route.params.subPath,
      startFilter: this.$store.state.storeImageTemplate.filterSubTemplate,
      private: true,
    });
  },
  destroyed() {
    window.removeEventListener("keydown", this.doCommand);
  },
  mounted() {
    this.dialogEditTemplate = true;
    setTimeout(() => {
      this.dialogEditTemplate = false;
    }, 500);
  },
};
</script>
<style>
@import "../../mixins/fonts/loadFonts.css";
</style>
